export const COMMON_CONSTANTS = {
  MAX_NUMBER_OF_BANS: 1000,
  FILTER: "subscriber,services,handset",
  PROMOTION_FILTER: "subscriber,services,handset",
  ACCOUNT: "Account",
  ACCOUNT_MANAGEMENT : "ACCOUNT_MANAGEMENT",
  INCLUDE_MSISDN : "IncludeMSISDN",
  SUBSCRIBER_LINE_DETAILS: "subscriber-line-details",
  TRANSACTION_ID: 'serviceTransactionId',
  QUERY_PARAM_UID:'queryParamUID',
  TEA_RESPONSE:'teaResponse',
  IS_OLM_ORG:'olmORG',
  IS_SPECTRUM_BARTER: 'isSpectrumBarter',
  UNDEFINED_KEY: 'undefined',
  NULL_KEY: 'null',
  CONTENT_CACHE_KEY: 'content',
  UNDERSCORE: '_',
  DOUBLE_HYPHEN: '--',
  DOUBLE_SPACE_HYPHEN: '- -',
  HYPHEN: '-',
  THREE_DOTS: '...',
  HIT_A_SNAG : 'hit-a-snag',
  ERROR_WITH_ZERO_DEVICES : 'error with zero devices',
  CHARACTER_REGEX: '^[a-zA-Z .-]*$',
  NUMBER_REGEX: '^[0-9]*$',
  VARCHAR_REGEX: '^[a-zA-Z0-9 .-]*$',
  BAN_NUMBER_KEY: 'ban',
  BAN_LIST_KEY: 'banList',
  MISDIN_DETAILS: 'msisdinDetails',
  BAN_LIST_RESPONSE: 'banListResponse',
  ACTIVITIES_DATA: 'activitiesData',
  BAN_FIRST_NAME_KEY: 'firstName',
  BAN_LAST_NAME_KEY: 'lastName ',
  NAME: 'name',
  DESCRIPTION: 'description',
  PORT_IN_PST_DATE: 'PST_Date',
  STACKABLE_PLAN:'Stackable_Plan',
  ROLE_ID: 'roleId',
  USER_ROLE_TEM: 'TEM',
  ACR_VALUES_PARAM: "&acr_values=loa3sa",
  RECORDS_PER_PAGE_CONFIRURATIONS: 100,
  ONE: 1,
  STATE_OKTA:'&state=okta',
  ORG_ID_KEY: 'OrgID',
  TRUE_TXT: 'true',
  BILL_PAY_FLAG: 'billPayflag',
  RETURN_URL_SSP: 'returnURI',
  EUI_CODE: 'code',
  FLOW_KEY: 'flow',
  USER_ID : 'userId',
  PRODUCT_TYPE_TXT: 'productType',
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  AM_LIST_ID: 'amList',
  LOGON_ROUTER_ID: 'logonId',
  MSISDN: 'Msisdn',
  CHANGE_SERVICE: 'changeservice',
  LINE_DETAILS: 'line-details',
  ERROR_CODE: 'TFB_ERR_42966',
  SUBMIT_ERROR_CODE: 'TFB_ERR_43006',
  SUBMIT_ERROR_CODE_BI: 'TFB_ERR_52255',
  DEVICE_Q_ERROR1: 'TFB_ERR_43026',
  DEVICE_Q_ERROR2: 'TFB_ERR_43027',
  ONE_TIME_TEXT: 'onetime',
  SELECTED_MSISDN: 'selectedMisdin',
  SELECTED_LINEDETAIL:'selectedLineDetail',
  SELECTED_LINE_SUBTYPE:'linesubtype',
  SUBSCRIBER_INFO: 'subscriberInfo',
  SUBSCRIBER_SERVICE: 'subscriberService',
  SUBSCRIBER_HANDSET: 'subscriberHandset',
  ENROLL_FLOW: 'enroll',
  IS_HANDSHAKE_COMPLETE: 'isHandshakeComplete',
  HANDSHAKE_ERROR_MSG: 'System is down, Please check back later',
  HANDSHAKE_FIRSTNAME: 'MAHESH',
  HANDSHAKE_LASTNAME: 'MAHESH',
  EUI_TOKEN_DATA: 'euiTokenDataAMapp',
  CHANGE_REQ_ID: 'chgreqOrderid',
  CHANGE_REQ_ITM_ID: 'chgreqOrderItmid',
  PAYMENT_CC: 'CC',
  PAYMENT_ACH: 'ACH',
  CREDIT_CARD_TXT: 'Credit Card',
  BANK_TRANSFER_TXT: 'Bank transfer',
  ROLE_CHOOSER: 'rolechooser',
  SHOW_ROLE_CHOOSER: 'showRoleChooser',
  RESTRICTED_ACCESS: 'restrictedaccess',
  DEFAULT_TIMEZONE: 'T00:00:00.000Z',
  DEFAULT_PORT_IN_TIMEZONE: 'T00:00:00.999Z',
  CURRENT_DATE_EFFECTIVE_CODE: 'T',
  NEXT_BILLING_CYCLE_EFFECTIVE_CODE: 'N',
  COUNT_ONE: '1',
  CHAR_S: 'S',
  CHAR_T: 'T',
  CHAR_N: 'N',
  CHAR_Q: 'Q',
  CHAR_M: 'M',
  NETFLIX_TXT: 'Netflix',
  NETFLIX_CAPS_TXT: 'NETFLIX',
  NETFLIX_SOC_INDICATOR: 'NFX',
  NETFLIX_PARTNER_LOADING_TEXTS: ["Processing your order.","Connecting to partner.","Creating your subscription.","Generating activation link."],
  NETFLIX_PARTNER_LOADING_TIMEOUT: 20000,
  HULU_SOC_INDICATOR: 'DHU',
  HULU_CAPS_TXT: "HULU",
  QUIBI_TXT: 'Quibi',
  MICROSOFT_TXT: 'Microsoft 365',
  PAGE_SIZE: 50,
  LIMIT: 12,
  LINES_LIMIT: 2,
  RECORDS_PER_PAGE: 100,
  RECORDS_PER_PAGE_TRANSACTION: 500,
  RECORDS_PER_PAGE_TEA_API: 500,
  RECORDS_PER_PAGE_APPROVAL_REQUEST_API: 99,
  DENIAL_TYPE: 'ALL',
  B2B_ORDER_TOKEN: 'B2b-order-token',
  ORDER_ID: 'orderId',
  PACKAGE_ID: 'packageId',
  CONTENT: 'contenttfbam',
  THRESHOLD_QTY: '100',
  WCS_ORDER_TOKEN: 'WCToken',
  WCS_TRUSTED_TOKEN: 'WCTrustedToken',
  ACCOUNT_ORDER_ID: 'accountOrderId',
  IS_TRANSFER_NUMBER: 'isTransferNumber',
  STATIC_TIME: '10:10:10 AM',
  FRAUD_ERROR_CODE : 'TFB_ERR_43020',
  SERVER_ERROR_MESSAGE: 'Server error occured',
  SERVER_ERROR_MSG: 'Server error occured, please try again after sometime',
  ACCOUNT_ORDER_HISTORY: 'account-orders-history',
  PLAN_CHANGE:'plan-change',
  EVALUATE_PROMOTIONS:'evaluate-promotions',
  VERIFY_MILITARY_STATUS:'verify-military-status',
  LOOKUP_AFFILIATION_INFO: 'lookup-affiliation-info',
  PAPERLESS_BILLING: 'paperless-billing',
  CHANGE_RATE_PLAN: 'rate-plans',
  CHANGE_RATEPLAN_SERVICES: 'services',
  SERVICE_CANCELLATION: 'service-cancellation',
  SERVICE_CANCELLATION_ELIGIBILITY: 'service-cancellation-eligibility',
  PLAN_CHANGE_EFFECTIVE_DATE:'plan-change-effective-date',
  LOOKUP_AFFILIATION_REF_INFO:'lookup-affiliation-reference-info',
  ENCRYPT_FIELD:'encrypt-field',
  VERIFY_MILITARY_AFFILIATION:'verify-military-affiliation',
  VERIFY_DOCUMENTS:'verify-documents',
  SUBSCRIBERS : 'subscribers',
  TOKENS_V6:'tokens',
  SERVICEAGGREMNET_API : 'service-agreement',
  SUBMIT_RATEPLAN :'submit-plan-change',
  USER_LIST_API:'user-list',
  STATUS_API:'status',
  CANCEL_SUBSCRIBER_ELIGIBILTY: 'service-cancellation-eligibility',
  CANCEL_SUBSCRIBER_API: 'cancel-subscriber',
  SIM_CHANGE_API: 'sim-change',
  SUBMIT_CART: "submitCart",
  SIM_CHANGE_ELIGIBILITY: 'sim-change-eligibility',
  SERVER_ERROR_TYPE: 'server',
  LOGON_ID: 'abc@t-mobile.com',
  API_DELAY: 500,
  DIFFTIME_KEY: 'diffTime-key',
  TRANSACTIONID: 'transactionID',
  CHANGESERVICEDATE:'ChangeServiceDate',
  B2B_REQUESTID: 'b2b-requestid',
  REQUEST_DATE: 'requestDate',
  LOGIN_PATH: '/login',
  LOCAL_TXT: 'local',
  IAM_USER_ID: 'Iam_User_Id',
  PNP_PERSISTED_CONTEXT: 'pnp-persisted-context',
  TRUE_VAL: true,
  FALSE_VAL: false,
  SPLUNK_CLIENTSIDE_ERROR: 'clientSide Javascript Error',
  FLOWTYPE: 'flowType',
  SPLUNK_URL: '/splunk-logs/services/collector/event',
  READ_ONLY_FLAG: '1',
  DNS_WINDOW: 'myWindow',
  TEXT_TYPE: 'text',
  INPUT_ID: 'doNotSellSettingId',
  POST: 'post',
  TFB: 'TFB',
  CHUB_ID:'chub_id',
  NO_SELL_WEB: 'NoSell_Web',
  ACCOUNT_HUB: 'AHUB',
  PRODUCT_TYPE_AH: 'AH',
  PRODUCT_TYPE_IOT: 'IOT',
  LH_TEXT: 'LH',
  DNS: '/dns',
  BRAND_TEXT: 'Brand',
  SITE_TEXT: 'Site',
  COLLABORATE_RATE_PLAN_TEXT: 'magenta_line_delta',
  ORIGINURL_TEXT: 'Origin_URL',
  HIDDEN_TEXT: 'hidden',
  INVALID_DATE: 'Invalid Date',
  BAN_STATUS: 'S',
  VOLUNTARY_SUSPENSION_TYPE: 'N',
  INVOLUNTARY_SUSPENSION_TYPE: 'D',
  IS_CHANGENUMBER_APPROVAL: 'isChangeNumberApproval',
  IS_RESTORE_APPROVAL: 'isRestoreApproval',
  IS_SUSPEND_APPROVAL: 'isSuspendApproval',
  IS_CHANGE_SERVICE_APPROVAL: 'isChangeServiceApproval',
  IS_PORT_IN_APPROVAL: 'isPortInApproval',
  IS_SIM_SWAP_APPROVAL: 'isSimSwapApproval',
  IS_CHANGE_RATE_PLAN_APPROVAL: 'isChangeRatePlanApproval',
  CHANGE_SERVICES: 'Change Services',
  END_USER:'ENDUSER',
  TEM_USER:'TEM',
  AMM_USER:'ACMAN',
  ROLE:'Role',
  ROLENEW: 'roleName',
  BO:'BO',
  IOT: 'IOT',
  TFBIOTACCOUNTADMIN: 'TFBIOTACCOUNTADMIN',
  PRODUCT_ID: 'productId',
  AUTH_TOKEN: 'authv6token',
  ORG_USER_TYPE:'org_user_type',
  EVALUATE_PROMO_URL:'/nodehap/b2b-experience/v4/lines-of-service/evaluate-promotions',
  DOCUMENTS_ID_URL: 'document-details',
  PAYMENT_DETAILS_URL: 'payment-detail',
  DNS_STYLE: 'width=800,height=800,resizeable,scrollbars',
  SUCCESS_TEXT : 'Successfully fetched Line details',
  BUSINESS_EXPERTS : 'Business Experts',
  BUSINESS_EXPERT : 'Business Expert',
  DUPLICATE: 'duplicate',
  REGEX_TMOBILE : /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@t-mobile.com$/,
  ORDER_TYPE: 'ACCOUNT_MIGRATION,LINE_IDENTIFIER_UPDATE,CHANGE_MOBILE_NUMBER,LINE_SOC_CHANGE,SUSPEND_REQUEST,RESTORE_REQUEST,BAN_AUTOPAY_ENROLL,BAN_AUTOPAY_UNENROLL,BAN_AUTOPAY_UPDATE_ENROLL,SIM_SWAP,ENROLL_PAPERLESS_BILL,UNENROLL_PAPERLESS_BILL,UPDATE_PAPERLESS_BILL_ENROLLMENT,BILL_PAYMENT,DELETE_SCHEDULED_PAYMENT,SCHEDULED_PAYMENT,CHANGE_MSISDN_PORTIN,CREATE_PAYMENT_ARRANGEMENT,EDIT_PAYMENT_ARRANGEMENT,CANCEL_PAYMENT_ARRANGEMENT,RATE_PLAN_CHANGE,CANCEL_SUBSCRIBER,EIP_STANDALONE_PAYMENT,MANAGE_PAIRING,TPOP_GENERATE,TPOP_CANCEL,SIM_PROTECTION_ADD,SIM_PROTECTION_REMOVE,PORT_PROTECTION_ADD,PORT_PROTECTION_REMOVE,SIM_DEVICE_LOCK,SIM_DEVICE_UNLOCK',
  ORDER_TYPE_IOT:'IOT_DIALPAD',
  DEVICE_TAB: 'Device',
  PLAN_AND_SERVICES: 'Plan & Services',
  USAGE: 'Usage',
  SINGLEBAN:'Single-BAN',
  MULTIBAN:'Multi-BAN',
  CARE:'Care',
  CUSTOMER:'Customer',
  AUTHENTICATED:'AUTHENTICATED',
  ORGNAME:'orgName',
  EQUIPMENT_INSTALLMENT_PLAN: 'Equipment Installment Plan',
  BLANK_HREF : 'javascript:void(0)',
  GOOGLE_ADDRESS_PROPERTIES: {
    LOCALITY: 'locality',
    ADMINISTRATIVE_AREA_LEVEL_1: 'administrative_area_level_1',
    POSTAL_CODE: 'postal_code',
    STREET_NUMBER: 'street_number',
    ROUTE: 'route',
  },
  DATE_REGEX:/^([0-9]{2})\/([0-9]{2})\/([0-9]{4})$/,
  USA_MSISDN_PATTERN_REGEX: /^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[2-9][02-9]1|[2-9][02-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/,
  NON_GEO_REGEX:/^(?:(?:\+?1\s*(?:[.-]\s*)?)?(?:\(\s*([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9])\s*\)|([2-9]1[02-9]|[2-9][02-8]1|[2-9][02-8][02-9]))\s*(?:[.-]\s*)?)?([2-9]1[02-9]|[1-9][01-9]{2})\s*(?:[.-]\s*)?([0-9]{4})(?:\s*(?:#|x\.?|ext\.?|extension)\s*(\d+))?$/,
  MASKING_INFORMATION : [
    {name:'BAN', type:'last4'},
    {name:'billingAccount', type:'last4'},
    {name:'billingAccounts', type:'last4'},
    {name:'billingAccountNumber', type:'last4'},
    {name:'ban', type:'last4'},
    {name:'msisdn', type:'last4'},
    {name:'password', type:'comp'},
    {name:'userId', type:'last4'},
    {name:'mobileNumber', type:'last4'},
    {name:'email', type:'last4'},
    {name:'logonId', type:'last4'},
    {name:'newMsisdn', type:'last4'},
    {name:'financialAccountNumber', type:'last4'},
    {name:'oldMsisdn', type:'last4'},
    {name:'firstName',type:'comp'},
    {name:'lastName', type:'comp'},
    {name:'newSim', type:'last4'},
    {name:'oldSim', type:'last4'},
    {name:'logonEmail',type:'last4'},
    {name:'submitterLogonId',type:'last4'},
    {name:'oldPassword',type:'comp'},
    {name:'newPassword',type:'comp'},
    {name:'bankRoutingNumber',type:'last4'},
    {name:'ntid', type:'last4'},
    {name:'Authorization',type:'total'},
    {name:'x-auth-originator',type:'total'},
    {name:'authtoken',type:'total'},
    {name:'ospAccount', type:'comp'},
    {name:'ospAccountPassword', type:'comp'},
    {name:'ospAccountNumber', type:'comp'},
    {name:'sim', type:'last4'},
    {name:'imei', type:'last4'},
    {name:'eid', type:'last4'},
    {name:'portInNumber', type:'last4'},
    {name:'fullName', type:'comp'}
    ],
  LAST_4:"last4",
  COMPLETE:"comp",
  TOTAL:'total',
  HEADER_PROPERTIES: {
    AUTHORIZATION_KEY: 'Authorization',
    BASIC_KEY: 'Basic ',
    ACCEPT_KEY: 'Accept',
    APPLICATION_JSON_KEY: 'application/json',
    BEARER_KEY: 'Bearer ',
    SENDER_ID_KEY: 'SAMSON',
    CHANNEL_ID_KEY: 'WEB',
    APPLICATION_ID_KEY: 'DASH',
    SALES_VALIDATION_CHANNEL_ID_KEY: 'TSL',
    B2B_CLIENT_KEY: 'B2b-client',
    B2B_ORG_KEY: 'B2b-org',
    CONTENT_TYPE_KEY: 'Content-Type',
    AUTH_TYPE: 'authType',
    MIME_TYPE_KEY: 'mimeType',
    B2B_USERID_KEY: 'B2b-userId',
    B2B_CCID_KEY: 'B2b-ccid',
    B2B_CLIENT_ID: 'TFB-AM-LH',
    B2B_CLIENT_ID_TFB_AM_APP: 'TFB-AM-APP',
    AUTH_TOKEN: 'authToken',
    NO_CACHE: 'no-cache',
    FORM_URL_ENCODED : 'application/x-www-form-urlencoded',
    OKTAAPPLICATION_JSON_KEY: 'application/x-www-form-urlencoded',
    LOGGER_CONTENT_KEY: 'application/x-www-form-urlencoded;charset=UTF-8',
  },
  PUBLICKEY_PROPERTIES: {
    APPLICATION_ID: '45454',
    ENCRYPTION_FORMAT: 'JWK',
  },
  OKTA_REDIRECT_URI: '{{okta_redirecturi}}',
  OKTA_ISSUER_CODE: '{{okta_issuercode}}',
  OKTA_CLIENT_ID: '{{okta_clientid}}',
  ACCESS_TOKEN_EXPIRY_KEY: 'access-token-expiry',
  ACCESS_TOKEN_KEY: 'access-token',
  ID_TOKEN: 'authToken',
  ORDER_TOKEN_KEY: 'order-token',
  ACCESS: 'access',
  TOKEN: 'token',
  ACCT_MGMNT_LOGIN_URL: '/apps/tfb_acctmgmt/account-management/login',
  UID_KEY: 'uid',
  // UID Flow Flag
  ENABLE_UID_FLOW: true,
  AUTH_TYPE: 'IDPType',
  IAM_KEY: 'iam',
  CLIENT_APP_NAME: 'clientAppName',
  TOKEN_KEY: 'token',
  SERVICE_TERMS_DATA: 'serviceTermsData',
  MANAGE_FLOW: 'manage',
  STATUS_FAILURE: 'FAILURE',
  BILL_PAY: 'billPay',
  EMAIL_ID: 'emailId',
  TWO: 2,
  NINE: 9,
  NONE: 'none',
  BLOCK: 'block',
  AUTO: 'auto',
  HIDDEN: 'hidden',
  MASKING_CHARACTERS: '****',
  ADRUM_JS_PATH: '//cdn.appdynamics.com/adrum/adrum-4.5.2.0.js',
  ICON_TYPE_CLS: {
    ICN_SUCCESS: 'valid_icon',
    ICN_WARNING: 'invalid_icon',
    ICN_INFO: 'info_icon',
  },
  ALERT_TYPES: {
    SUCCESS: 'Success',
    WARNING: 'Your transaction cannot be processed at this time',
    INFO: 'Information',
    ACCESS_TOKEN_EXPIRED: 'Access Token Expired!',
    REDIRECT_TO_LOGIN_MSG: 'You are being redirected to login page. Please try again after login.',
    SUCCESS_MESSAGE: 'Successfully fetched Line details',
    FAILURE: 'Failure',
    IMS_SUSPEND_WARNING :'The line is suspended under implementation suspension. To restore the line, please have an authorized user on the account contact Business Care by dialing 1-800-375-1126 or 611 from their T-Mobile phone.',
    TRANSACTION_FAILURE : 'Your transaction cannot be processed.'
  },
  OK: 'Ok',
  CLIENT_NAME: {
    SSP: 'SSP',
    BOSS: 'BOSS',
    VENICOM: 'VENICOM',
  },
  TEXT_BACK: 'Back',
  CLOSE: 'Close',
  TEST: 'test',
  DONE: 'Done',
  CANCEL: 'Cancel',
  SELECTED_BAN_QUERY_PARAM: '?selectedBAN=',
  SYMBOLS: {
    FORWARD_SLASH: '/',
    CROSS: 'x',
    BRACKET_OPEN: '(',
    BRACKET_CLOSE: ') ',
    DASH: '-',
    DASH_SPACE: ' - ',
    COLON: ':',
    COMMA: ',',
    SPACE_SLASH: ' / '
  },
  DIGITS: {
    FIVE: 5,
    FOUR: 4,
    ZERO: 0,
    EIGHT: 8,
    THREE: 3,
    MINUS_ONE: -1,
    ONE: 1,
    THIRTEEN: 13,
    NINETEEN: 19,
    TWENTY: 20,
    TEN: 10,
    NINE: 9,
    FIFTEEN: 15,
    TWO: 2,
    SIX: 6,
    SEVEN: 7,
    TWENTY_FOUR: 24,
    SIXTY: 60,
    TWELVE: 12,
    THIRTY: 30,
    THIRTY_ONE: 31,
    FORTY:40,
    FORTY_NINE:49,
    NINTY: 90,
    FIVE_THOUSAND: 5000,
    FOURTEEN :14,
    SIXTEEN: 16,
    ONE_HUNDRED_EIGHTY: 180,
    TWO_HUNDRED_FIFTY: 250,
    THOUSANDS: 1000,
    ONE_HUNDRED_YEARS_IN_DAYS: 36500,
    CONST_CONVERT_TO_DAYS: 60*60*24*1000
  },
  SHOW_20: 'Show 20',
  PAGINATION_LIST: ['Show 10', 'Show 20', 'Show 50', 'Show 100' ],
  BILLING_ADDRESS_STATE_LIST: ['AK', 'AL', 'AR', 'AZ', 'CA', 'CO', 'CT', 'DE', 'FL', 'GA', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY', 'LA', 'MA',
    'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC', 'ND', 'NE', 'NH',   'NJ', 'NM', 'NV', 'NY', 'OH', 'OK', 'OR', 'PA', 'RI', 'SC', 'SD', 'TN',
    'TX', 'UT', 'VA', 'VT', 'WA', 'WI', 'WV', 'WY'],
  FILTER_DATA: 'filterData',
  ALL: 'All',
  LENGTH_TXT : 'length',
  STRING_TXT: 'string',
  STRING_EMPTY: '',
  STRING_SPACE: ' ',
  NEW_LINE:'\n',
  NEW_LINE_R:'\r\n',
  FORWARD_SLASH:'/',
  INLINE_TXT: 'inline',
  AUTHORIZATION_CODE: 'authorization_code',
  OKTA_ACCESS_TOKEN_KEY: 'oktaAccessToken',
  OKTA_ID_TOKEN : 'id_token',
  OKTA_AUTH_CODE_KEY: 'oktaAuthCode',
  OKTA_USER_PROFILE: 'okta_userProfile',
  AZURE_ACCESS_TOKEN_KEY: 'azureAccessToken',
  AZURE_ID_TOKEN : 'id_token',
  OKTA_KEY: 'okta',
  AZURE_KEY: 'azure',
  APP_TITLE: 'angular-account-management',
  HOME_URL: '/apps/tfb_acctmgmt/account-management/home',
  ROUTES_TXT: 'routes',
  DEALER_CODE_VAL: '0000002',
  RESTRICT_PAGE_URL: '/apps/tfb_acctmgmt/account-management/restrict-page',
  CALLBACK: 'implicit/callback',
  ORDER_TOKEN_TXT: 'orderToken',
  METADATA: 'metaData',
  BODY: 'body',
  HIDE_LOADER_ICON: 'hideLoaderIcon',
  ERROR_KEY: 'errorKey',
  ERROR_MESSAGE: 'errorMessage',
  GET_METHOD: 'GET',
  PAR_PROP: 'par',
  SUCCESS_ERROR_TYPE: 'SucessError',
  BILLING_ACCT_URL: '/b2b-experience/v1/billing-accounts',
  TEMP_ERROR: 'Temporary Error',
  SERVICE_ERROR: 'Error in Service',
  ERROR_FROM_SERVER: 'Getting Error From Server',
  EXPIRY_TOKEN_ERROR_CODE : 'Security-1004',
  TOKEN_ERROR_CODE_1001 : 'Security-1001',
  TOKEN_ERROR_CODE_1008 : 'Security-1008',
  TOKEN_ERROR_CODE_1014 : 'Security-1014',
  ACCESS_TOKEN_EXPIRED : 'Access token expired',
  INVALID_API_KEY : 'Invalid API Key',
  INVALID_ACCESS_TOKEN : 'Invalid Access Token',
  INVALID_ACCESS_TOKEN_ISSUER: 'Invalid Access Token Issuer',
  ENABLE_ENDUSER:"enableEndUser",
  EXPORT_MAGENTA_IMG:"/assets/tfb-acctmgmt/images/Export_Magenta.svg",
  DIALPAD_SETTINGS_IMG: "/assets/tfb-acctmgmt/images/vector.svg",
  DEPENDENCY: "dependency-",
  EXTOFFERID: "EXTOFFERID",
  SPLUNK_PROPERTIES: {
    SERVER_SIDE_LOG: 'Server-Side Log',
    CONTENT_TYPE_KEY: 'Content-Type',
    ADRUM: 'ADRUM',
    CUSTOM_HTTP_HEADERS: '_customHttpHeaders',
    HEADERS: 'headers',
    REQUEST_DATE: 'requestdate',
    B2BREQUESTID: 'b2brequestid',
    SUBMIT_CALL: 'submitCall',
    FLOW_TYPE: 'flowType',
    API_NAME: 'apiName',
    REDFLAG: 'redFlag',
    UNHANDLED_EXCEPTION: 'Unhandled Exception -  at _mapLoggingPayload - in HttpLoggingInterceptor - ',
  },
  COOKIE_NOTAVALIABLE_MESSAGE: "Your session is invalid, redirecting you to Org serach page",
  COOKIE_NOTAVALIABLE_CODE: "ERR_INVALID_COOKIE",
  ENTITLEMENT_ACTIVITIES: 'entitlementActivities',
  ALL_TYPES_SERVICE: {
    BLK: 'BLK',
    DATA: 'Data',
    BLOCKING: 'Blocking',
    OTHER: 'Other',
    DATA_CAPS: 'DATA',
    BLOCKING_CAPS: 'BLOCKING',
    OTHER_CAPS: 'OTHER',
    ALL_SERVICES: 'All services',
    CURRENT_SERVICES: 'Current services',
    AVAILABLE_SERVICES: 'Available services',
    ALL_TYPES: 'All types',
    ALLSERVICES: 'allServices',
    SERVICES_LIST: 'servicesList'
  },
  TERMS_CONDITIONS: 'TERMS_CONDITIONS',
  BUSINESS_ADVISEMENT:'BUSINESS_ADVISEMENT',
  SERVICE_AGREEMENT: 'SERVICE_AGREEMENT',
  TERMS_CONDITIONS_DATA: 'termsAndConditionsData',
  SERVICE_AGREEMENT_DATA: 'serviceAgreementData',
  EMAIL_TEXT: 'EMAIL',
  SERVICES: {
    INITIAL_SERVICES_LIST: 'initialServicesList',
    SERVICES_LIST_CURRENT_STATE: 'servicesListCurrentState',
    CURRENT_SERVICE: 'currentService',
    PREVIOUS_SERVICES_TOTAL: 'previousServicesTotal',
    CURRENT_SERVICES_TOTAL: 'currentServicesTotal',
    REVIEW_CHANGE_SERVICE_DATA: 'reviewChangeServiceData',
    REVIEW_CHANGE_SERVICE: 'reviewchangeservice',
    ADDITION: 'ADDITION',
    REMOVAL: 'REMOVAL',
    K2K_SOCS: ['ZM365B', 'ZM365B2', 'ZM365PB', 'QUIBITMO', 'QBIONUS'],
    K2K_SOCS_QUIBI: ['QUIBITMO', 'QBIONUS'],
    K2K_SOCS_M365: ['ZM365B', 'ZM365B2', 'ZM365PB'],
    SCAM_SOCS: ['SCAMIDOFF', 'SCAMMIOFF', 'SCAMIDOFFP', 'SCAMMIOFFP'],
    SB_SOC_BD: 'ZBLOCKMI',
    SB_SOC_CFC: 'MBBWEBGRD',
    CURRENT_SERVICE_ON_LOAD:"currentServicesOnLoad",
    ADDED_SERVICES:'addedServices',
    REMOVED_SERVICES:'removedServices',
    CURRENT_SELECTED_SERVICES:'currentSelectedServices',
    ACTIVE_STATUS_CODE:'A',
    DESC_DETAILS: 'descDetails',
    REMOVE_SERVICES:'removeServices',
    SB_CHANGE_SERVICE_POPUP: 'Transaction is not currently allowed. Change services request is already pending for this line of service.',
    CJ_SOC_ZBLK: 'ZBLKSATCV',
    CJ_SOC_ZDCL: 'ZDCLSATCV'
  },
  CHANGE_SERVICE_MSISDN: 'changeServiceMsisdn',
  CANCEL_SERVICE: {
    BALANCE_DUE: 'balanceDue',
    ERROR_TITLE: 'Looks like we hit a snag',
    ERROR_BODY: 'Don’t worry—it’s us, not you. Try again, and if you need assistance, please call Business Care at 1-800–375–1126.',
    FAILURE_002: 'FAILURE-002',
    TFB_ERR_42938: 'TFB_ERR_42938',
    FAILURE_002_TITLE: 'Unable to cancel subscriber',
    FAILURE_002_BODY: 'We couldn’t cancel the subscriber because there’s already an active cancellation on this line. If you need help, call Business Care at 1-800-375-1126.',
    EIP_BALANCE_ERROR: 'TFB_ERR_42940'
  },
  FIRST_RESPONDER_FAILURE: {
    TITLE: 'Your status couldn’t be verified',
    MESSAGE: 'Sorry, you’ll need to start the verification process over at contact Business Care by calling 1-800–375–1126 or 611 from your T-Mobile phone.',

  },
  SERVICE_LEVEL: {
    SUBSCRIBER: 'SUBSCRIBER',
    ACCOUNT: 'ACCOUNT',
    PRODUCT: 'PRODUCT',
    RATE_PLAN_CHANGE: 'RATE_PLAN_CHANGE'
  },
  PACKAGE: {
    CURRENT_SERVICE: 'currentService',
    STATUS: 'status',
    CONFLICTING_WITH: 'conflictingWith',
    LEVEL: 'level',
    CATEGORY: 'category',
    GROUP : 'group',
    PROTECTION_PLAN: 'ProtectionPlan',
    SERVICE_CODE: 'serviceCode',
    SERVICE_SEQUENCE_NBR: 'serviceSequenceNumber',
    EFFECTIVE_DATE_TYPE: 'effectiveDateType',
    EFFECTIVE_DATE: 'effectiveDate'
  },
  SUBSCRIBER_DATA: 'SubscriberData',
  FULL_NAME: 'Gireesh babu',
  HTML: 'HTML',
  SERVICE_STATUS: {
    REMOVED: 'Removed',
    ADDED: 'Added'
  },
  UNLOCK_STATUS: {
    PERMANENT: 'PERMANENT',
    TEMPORARY: 'TEMPORARY',
    UNKNOWN: 'UNKNOWN',
    LOCKED: 'LOCKED',
    UNLOCKED: 'UNLOCKED',
  },
  LH_AD_GROUPS: ["oes_lighthouse_all", "oes_lighthouse_portin"],
  ACTION_HYPERLINK: {
    CHANGE_SIM: 'Change SIM',
    SUSPEND_LINE: 'Suspend line',
    RESTORE_LINE: 'Restore line',
    TANSFER_NUMBER: 'Transfer number',
    CHANGE_NUMBER: 'Change number',
    LINE_IDENTIFIER: 'Update line identifier',
    CHANGE_SERVICES: 'Change services',
    VIEW_LINE_HISTORY: 'View line history',
    LINE_HISTORY: 'View line history',
    ENDUSER_SUSPEND_LINE: 'Report lost or stolen',
    ENDUSER_UPGRADE_DEVICE: 'Upgrade Device',
    CHANGE_RATE_PLAN:'Change rate plan',
    CANCEL_SUBSCRIBER:'Cancel Subscriber',
    MANAGE_PAIRING: 'Manage watch pairing',
    GENERATE_PORT_OUT_PIN :'Generate Port Out PIN'
  },
  NON_GEO__AREA_CODE:['500', '521', '522', '523', '524', '525', '526', '527', '528', '529', '533', '544', '566', '577', '588',
    '532', '538', '542', '543', '545', '547', '549', '552', '553', '554', '556', '569', '578', '550', '535', '546', '558'],
  NON_GEO__COUNTRY_CODE_EXCLUDES:['911','555'],
  HOST_PLACEHOLDER: '{{host}}',
  CLIENT_PLACEHOLDER: '{{client}}',
  REDIRECT_URL: 'reDirectionUrl',
  UPGRADE_DISABLED_MSG : 'The device is not eligible for an upgrade.',
  TAB: "tab",
  HASH:"#",
  SHOW: "show",
  BLUR: "blur",
  ANCHOR: "a",
  NEXTBILLINGCYCLEDATE:"nextBillingCycleDate",
  APPROVALFLAGS:"approvalFlags",
  LH_SUFFIX:"_LH",
  AH_SUFFIX:"_AH",
  EN_US: 'en-US',
  LA_TIMEZONE: 'America/Los_Angeles',
  CART_ID: '1234666',
  BAN_STATUS_CODES: {
    "SUSPEND": "S"
  },
  MM_dd_YYYY: "MM/dd/YYYY",
  packageType_IOTDP: "IOTDP",
  SAMSON_BILLER_CODE: "SAMSON",
  POSTPAID_BUSINESS_SEGEMENT: "POSTPAID",
  TMOBILE_BUSINESS_UNIT: "TMOBILE",
  U1POSTPAIDLEGACY_PROGRAMCODE: "U1POSTLEGACY",
  WEB_SALES_CHANNEL_ID: "WEB",
  SOFT_GOODS_PRODUCT_GROUP: "SOFTGOODS",
  MANAGE_PAYMENT_ORDER_TYPES: "MANAGEPAYMENT",
  QUERY_AUTOPAY_FLOW: "QUERY",
  APD_DAYS_PAST_LIMIT: 90,
  DISCOUNT_ELIGIBILITY_DECISION_INDICATOR_Y: "Y",
  DISCOUNT_ELIGIBILITY_DECISION_INDICATOR_N: "N",
  PAYMENT_METHOD_DISCOUNT_ELIGIBILITY_INDICATOR_N: "N",
  REGEX500RANGE: /^(5\d\d)/,
  BAN_HAS_GSM_AND_DIGITS: "banHasGSMAndDigits",
  STRATEGIC_PORT_IN_ORDER_TYPE: "STRATEGIC_PORT_IN",
  STRATEGIC_PORT_IN_CTA_TXT: 'Strategic Port In',
  REGEX400RANGE: /^(4\d\d)/,
  REGEX200RANGE: /^(2\d\d)/,
  MINIMUM_EXPIRATION_DATE:30,
  STRATEGIC_PORTIN_FILENAME:"Resend_Transaction",
  FETCH_BLOCK_STATUS_RESPONSE: "fetchBlockStatusResponse",
  SUBSCRIBERS_INFO: "SUBSCRIBERS_INFO",
  TFB_ERR_46238 : "TFB_ERR_46238",
  BAD_REQUEST : "BAD_REQUEST",
  SELECTED_FRANCHISEE: "SELECTED_FRANCHISEE"
};


export enum IOT_FLOW_TYPE {
  CW = 1,
  PP = 2,
  BSS = 3,
  CONNECTIVITY = 4,
  DIALPAD = 5,
  FRANCHISEE = 6
}

export enum ITEMS_PRIORITY {
  OTHER = 1,
  BLOCKING,
  DATA
}
export enum MILITARY_RADIO {
  VETERAN = "Veteran or Retiree",
  Active_DUTY = "Active Duty",
  RESERVIST = "National Guard or Reserve",
  MILITARY_FAMILY = "Gold Star"
}

export enum IOT_ACCOUNT_STATUS{
  TEST_READY = "TEST_READY",
  ONHOLD= 'ONHOLD',
  ACTIVATION_READY = "ACTIVATION_READY",
  ACTIVATED = "ACTIVATED",
  DEACTIVATED = "DEACTIVATED",
  REPLACED = "REPLACED",
  INVENTORY = "INVENTORY",
  RETIRED = "RETIRED",
  PURGED = "PURGED"
}

export enum PACKAGE_PRODUCT_LINE_STATUS{
  CANCELLED = "CANCELLED",
  ACTIVATED = "ACTIVATED",
  PENDING = "PENDING"
}

export enum PACKAGE_PRODUCT_PRODUCT_TYPE {
  SERVICE = "SERVICE",
  FINANCIAL = "FINANCIAL",
  DEVICE = "DEVICE",
  ACCESSORY = "ACCESSORY",
  PREMIUMCONTENT = "PREMIUMCONTENT",
  RATEPLAN = "RATEPLAN",
  BUNDLE = "BUNDLE",
  ADDON = "ADDON"
}

export enum RECURRING_FREQUENCY {
   MONTHLY = "MONTHLY",
   WEEKLY ="WEEKLY",
   SEMIMONTHLY = "SEMIMONTHLY",
   BIWEEKLY = "BIWEEKLY",
   YEARLY = "YEARLY",
   QUARTERLY = "QUARTERLY",
   ONETIME = "ONETIME",
   DAILY = "DAILY"
}

export enum IOT_BUSINESS_SEGMENT {
  IOTCONNECTIVITY = "IOTCONNECTIVITY",
  PACKAGE_PRODUCTS = "PACKAGEDPRODUCTS",
  DIAL_PAD = "DIALPAD",
  BUSINESS_SOFTWARE_SOLUTIONS ="BUSINESSSOFTWARESOLUTIONS"
}

export const TRANSACTION_HISTORY_CONSTANTS: any = {
  ORDER_ID_PARAM: '{{orderid}}',
  DOCUMENT_ID: '{{documentId}}',
  DOC_RETURN_TYPE_PARAM: '{{documentReturnType}}',
  DOC_RETURN_TYPE : 'CONTENT',
  TERMS_CONDITIONS: 'TERMS_CONDITIONS',
  TERMS_CONDITIONS_PDF: 'TermsAndConditions.pdf',
  SERVICE_AGREEMENT: 'SERVICE_AGREEMENT',
  SERVICE_AGREEMENT_PDF: 'ServiceAgreement.pdf',
  AUTOPAY_AGREEMENT: 'AUTOPAY_AGREEMENT',
  AUTOPAY_AGREEMENT_PDF: 'AutopayAgreement.pdf',
  BUSINESS_ADVISEMENT: 'BUSINESS_ADVISEMENT',
  BUSINESS_ADVISEMENT_PDF: 'BusinessAdvisement.pdf',
  PAPERLESS_PDF: 'PaperlessBillingAgreement.pdf',
  PAPERLESS_TXT: 'paperless',
  APPLICATION_PDF: 'application/pdf',
  DATA_APPLICATION_PDF: 'data:application/pdf,',
  REDIRECT_TO_HISTORY_DETAILS_PAGE: '/apps/tfb_acctmgmt/account-management/transactions/transaction-details',
  ALL_TYPE: 'All types',
  ALL_TIME: 'All times',
  ALL_ACCOUNTS: 'All accounts',
  ALL_LINES: 'All lines',
  ALL_TIME_VIEWLINE: 'All dates',
  ALL_STATUSES: 'All statuses',
  TRANSACTION_HISTORY: 'TransactionHistory',
  ACCOUNT_HISTORY: 'AccountHistory',
  REDIRECT_TO_LOGIN_PAGE: 'apps/tfb_acctmgmt/account-management/login',
  LAST_12: 'last12',
  ACCOUNT_OREDER_ID: 'accountOrderId',
  ACCOUNT_ORDER_TYPE: 'accountOrderType',
  SUMBITTER_LOGIN_ID: 'submitterLogonId',
  ACCOUNT_ORDER_STATUS: 'accountOrderStatus',
  SUBMITTED_DATE_TIME: 'submittedDateTime',
  DESCRIPTION: 'description',
  LAST_24_HOUR: 'Last 24 hours',
  LAST_7_DAYS: 'Last 7 days',
  LAST_30_DAYS: 'Last 30 days',
  LAST_3_MONTH: 'Last 3 months',
  LAST_6_MONTH: 'Last 6 months',
  LAST_12_Month: 'Last 12 months',
  ORG_ID_PLACEHOLDER: '{{orgId}}',
  YESTERDAY : 'Yesterday',
  LINE_IDENTIFIER_UPDATE_REQUEST :'Line Identifier Update Request',
  LINE_IDENTIFIER_UPDATE :'Line Identifier Update',
  BAN_AUTOPAY_ENROLLMENT:'BAN Autopay Enrollment',
  AUTOPAY_ON:'AutoPay: On',
  BAN_AUTOPAY_UNENROLLMENT:'BAN Autopay UnEnroll',
  STRATEGIC_PORT_IN:'Strategic Port In',
  AUTOPAY_OFF:'AutoPay: Off',
  AUTOPAY_ENROLLMENT:'AutoPay Enrollment',
  AUTOPAY_UNENROLLMENT:'AutoPay Unenrollment',
  MOBILE_NUMBER_CHANGE:'Mobile Number Change',
  NUMBER_CHANGE:'Number Change',
  PAPERLESS_BILLING_ENROLLMENT_UPDATE:'Paperless Bill Enrollment Update',
  PAPERLESS_BILLING_ENROLLMENT:'Paperless Billing Enrollment',
  PAPERLESS_BILL_ENROLLMENT:'Paperless Bill Enrollment',
  PAPERLESS_BILL:'Paperless Bill',
  PAPERLESS_BILLING_UPDATE:'Paperless Billing Update',
  PAPERLESS_BILLING_UN_ENROLLMENT:'Paperless Bill Un-Enrollment',
  PAPERLESS_BILLING_UNENROLLMENT:'Paperless Billing Unenrollment',
  DELETE_SCHEDULED_PAYMENT_REQUEST:'Delete Scheduled Payment Request',
  PAYMENT_CANCEL:'Payment- Cancel',
  BILL_PAYMENT_REQUEST:'Bill Payment Request',
  PAYMENT_ONETIME:'Payment- One Time',
  SCHEDULED_PAYMENT_REQUEST:'Scheduled Payment Request',
  PAYMENT_SCHEDULE:'Payment- Schedule',
  DELETE_PAYMENT_AGREEMENT_REQUEST:'Delete Payment Agreement Request',
  PAYMENT_AGREEMENT_DELETE:'Payment Arrangement - Delete',
  CREATE_PAYMENT_ARRANGEMENT:'Create Payment Arrangement Request',
  PAYMENT_AGREEMENT_CREATE:'Payment Arrangement - Create',
  EDIT_PAYMENT_ARRANGEMENT:'Edit Payment Arrangement Request',
  PAYMENT_AGREEMENT_EDIT:'Payment Arrangement - Edit',
  SIM_SWAP_REQUEST:'SimSwap Request',
  SIM_CARD_CHANGE:'SIM Card Change',
  LINE_SOC_CHANGE:'Line SOC Change',
  SERVICE_CHANGE:'Service Change',
  RESTORE_SERVICE:'Restore Service',
  SERVICE_RESTORATION:'Service Restoration',
  SUSPEND_SERVICE:'Suspend Service',
  SERVICE_SUSPENSION:'Service Suspension',
  PAIRING_UNPAIRING: 'Device Pairing',
  BAN_AUTOPAY_ENROLLMENT_UPDATE:'BAN Autopay Enrollment Update',
  AUTOPAY_UPDATE:'AutoPay Update',
  PARTIAL_FAILURE : 'Partial Failure',
  SUCCESS_LINE_DETAILS : 'Success line details',
  PARTIAL_FAILURE_INE_DETAILS : 'Partial failure line details',
  LINE_TXT:' line',
  LINES_TXT:' lines',
  BAN_TILDE:'~ban~',
  TOTAL_LINECOUNT_TILDE:'~totalLineCount~',
  ACCOUNT_TXT:'Account #',
  TRANSFER_NUMBER:'Transfer Number',
  APPROVED: '1 line approved',
  REJECTED: '1 line rejected',
  NOTAVAILABLE: '1 line submitted',
  PENDINGAPPROVAL: '1 line pending for approval',
  RATE_PLAN_CHANGE: 'Rate Plan Change',
  CANCEL_SERVICE: 'CANCEL_SUBSCRIBER',
  CANCEL_SUBSCRIBER:'Cancel Subscriber',
  CANCEL_DATE: 'Cancel Date',
  REQUEST_DATE: 'Request Date',
  REASON: 'Reason',
  ORDER_ID_PLACEHOLDER:'{{order-id}}',
  TRANSACTION_TYPE:'IOT_DIALPAD',
  ADDED: 'Added',
  REMOVED: 'Removed',
  ACCOUNT_MIGRATION: 'Account_Migration',
  ACCOUNT_MIGRATION_DESCRIPTION: 'Migrated account from Sprint to T-Mobile'
};

export const ACCOUNT_ORDER_STATUS :any ={
  PENDING : 'PENDING',
  FAILURE : 'FAILURE',
  SUCCESS : 'SUCCESS',
  PARTIAL_FAILURE :'PARTIAL FAILURE',
  APPROVED :'APPROVED',
  REJECTED :'REJECTED',
  ERROR:'ERROR',
  FAILURE_STATUS:'Failure',
  SUBMITTED:'Submitted',
  SUBMITTED_C:'SUBMITTED',
  CANCELLED:'CANCELLED',
  NOTAVAILABLE:'Not Available',
  PENDINGAPPROVAL: 'PENDING APPROVAL',
  PENDINGAPPROVAL_LOWER:'Pending Approval',
  APPROVED_VALUE: 'Approved',
  REJECTED_VALUE:'Rejected',
  SUCCESSFULLY_SUBMITTED:'Successfully Submitted',
  OPEN:"OPEN"
};

export const MANAGE_LINE_CONST = {
  ACTIVE_SUSPEND: 'Active_Suspend',
  AUTO_PAY_ON:'ON',
  AUTO_PAY_OFF:'OFF',
  DISABLE_LINE_ID:'disabledLineId',
  PAGE_SIZE: 20,
  ALL_STATUSES: 'All statuses',
  ALL_STATUS: 'All Status',
  ACTIVE_LOWERCASE: 'Active',
  CANCELLED_LOWERCASE: 'Cancelled',
  STATUS: 'Status',
  SUCCESSFULLY_SUBMITTED:'SUCCESSFULLY SUBMITTED',
  REDIRECT_TO_MANAGE_LINES: '/apps/tfb_acctmgmt/account-management/lines',
  REDIRECT_TO_MANAGE_LICENSES: '/apps/tfb_acctmgmt/account-management/licenses',
  REDIRECT_TO_TRANSACTION_HISTORY: '/apps/tfb_acctmgmt/account-management/transactions/transaction-history',
  REDIRECT_TO_HOME: '/apps/tfb_acctmgmt/account-management/home',
  FOOTER_LINE_IDENTIFIER: 'lineIdentifierBox',
  REDIRECT_TO_LINE_DETAILS: '/apps/tfb_acctmgmt/account-management/line-details',
  // REDIRECT_TO_CHANGE_SERVICES: '/apps/tfb_acctmgmt/account-management/line-details/changeservice',
  REDIRECT_TO_CHANGE_SERVICE: '/apps/tfb_acctmgmt/account-management/lines/changeservice',
  REDIRECT_TO_CHANGE_S_REVIEW: '/apps/tfb_acctmgmt/account-management/lines/changeservice/reviewchangeservice',
  REDIRECT_TO_CHANGE_S_CONFIRMATION: '/apps/tfb_acctmgmt/account-management/lines/changeservice/confirmation',
  BAN: 'ban',
  INVOLUNTARY_SUSPENSION_FLAG: 'involuntarySuspendedBan',
  INVOLUNTARY_SUSPENDED_BAN: 'involSuspendBan',
  CONFIG: 'configResponse',
  SELECTED_BAN_DETAIL: 'selectedBanDetails',
  AFFILIATIONSTATUSRESPONSE: "affiliationStatusResponse",
  COMPLETED: 'COMPLETED',
  COMPLETE:'COMPLETE',
  SUBMITTED:'SUBMITTED',
  NOT_COMPLETED: 'NOT COMPLETED',
  PARTIAL: 'PARTIAL',
  PENDING: 'PENDING',
  PENDING_FULFILLMENT: 'PENDING FULFILLMENT',
  FAILURE: 'FAILED',
  REVERIFY: 'REVERIFY',
  Y_CTA: 'Y',
  N_CTA: 'N',
  YES_CTA: 'Yes',
  NO_CTA: 'NO',
  NO_TEXT: 'No',
  YES_CHECK: 'YES',
  ACTIVE: 'ACTIVE',
  RESERVED: 'RESERVED',
  CANCELLED: 'CANCELLED',
  CANCELED: 'CANCELED',
  ML_INACTIVE: "mlInactive",
  PTT_INACTIVE: "pttInactive",
  SUBLINETYPE_PTT: "PTT",
  SUBLINETYPE_ML: "ML",
  ML_PTT_DEVICE_ID: "UNSIMVIRTUAL",
  ML_PTT_DEVICE_ID_SERV: "175651",
  OBJECT: 'object',
  AUTHENTICATION_INFO: 'auth_info',
  SUSPENDED: 'SUSPENDED',
  SUCCESS: 'SUCCESS',
  SUCCESS_CODE: 200,
  SUSPEND_DATE: '[suspendDate]',
  TARGET_SERVICE_NAME: 'targetServiceName',
  RESTORE_SERVICE: 'restore-service',
  REQUESTS: 'requests',
  ORGID: 'orgId',
  ORGID_LH_HOLDER: ':orgId_LH',
  MSISDN: 'Msisdn',
  REASON_CODE: 'reasonCode',
  RESTORE_DATE: 'restoreDate',
  EMAIL: 'email',
  DEALER_CODE: 'dealerCode',
  VALIDATOR_TYPE: 'validatorType',
  ENABLE_LINE_IDENTIFIER_CACHE: 'Enable_Line_Identifier',
  ENABLE_PORT_IN: 'Enable_portIn',
  ZIP_CODE: 'zip_code',
  MSS: 'MSS',
  ELST: 'ELST',
  SSQ: 'SSQ',
  IMS: 'IMS',
  TMPS: 'TMPS',
  RSQ: 'RSQ',
  RSS: 'RSS',
  EDUS: 'EDUS',
  MIMS: 'MIMS',
  SUNC: 'SUNC',
  PREFERENCE_CODES : [
    { name: 'Area Code', value: 'area_code' },
    { name: 'Market Code', value: 'market_code' },
    { name: 'Zip Code', value: 'zip_code' },
  ],
  NPA_ERROR_MSG: 'Please enter a valid value',
  REASON_FOR_CHANGE_ERROR: "Please Select Reason for Change",
  ENABLE_CHECKBOX : 'enableCheckBox',
  ASSIGN_INDIVIDUAL : 'assignIndividual',
  SUCCESS_VALIDATOR : 'successValidator',
  ERROR_VALIDATOR : 'errorValidator',
  DISABLE_CHECKBOX : 'disableCheckBox',
  OVERRIDE_CHANGES : 'overrideChanges',
  DISCARD_CHANGES : 'discardChanges',
  ASSIGN_ALL : 'Assign all',
  BAN_NUMBER_INVALID: 'Invalid BAN for Organization',
  PREVIOUS_SELECTED_LINES: 'previousSelectedLines',
  BAN_PLCHOLDER: '{{BAN}}',
  ORGID_PLCHOLDER: '{{orgID}}',
  MSISDN_PLCHOLDER: '{{msisdn}}',
  CHANGE_NUMBER_CTA_TXT: 'Change number',
  MANAGE_DIGITS_TXT:'Manage myDIGITS',
  SIM_CHANGE_CTA_TXT: 'Change SIM',
  SUSPEND_CTA_TXT: 'Suspend line',
  SUSPEND_LINES_CTA_TXT: 'Suspend line',
  RESTORE_CTA_TXT: 'Restore line',
  MORE_CTA_TXT: 'More',
  TRANSFER_NUMBER_CTA_TXT: 'Transfer number',
  TRANSFER_NUMBERS_CTA_TXT: 'Transfer numbers',
  UPDATE_LINE_IDENTIFIER_CTA_TXT: 'Update line identifier',
  CHANGE_SERVICE_CTA_TXT: 'Change Service',
  CANCEL_SERVICE_CTA_TXT: 'Cancel Subscriber',
  MANAGE_PAIRING_CTA_TXT: 'Manage watch pairing',
  MANAGE_SIM_SWAP_BLOCK_CTA_TXT: 'Manage Sim Swap Block',
  PORT_OUT_ON_PROTECTION_CTA_TXT: 'Turn on Port Out Protection',
  PORT_OUT_OFF_PROTECTION_CTA_TXT: 'Turn off Port Out Protection',
  MANAGE_PORT_OUT_PROTECTION_CTA_TXT: 'Manage Port Out Protection',
  TURN_ON_SIM_PROTECTION_CTA_TXT: 'Turn On SIM Protection',
  TURN_OFF_SIM_PROTECTION_CTA_TXT: 'Turn Off SIM Protection',
  MANAGE_SIM_PROTECTION_CTA_TXT: 'Manage SIM Protection',
  SIM_DEVICE_LOCK_CTA_TXT:"Lock SIM to device" ,
  SIM_DEVICE_UNLOCK_CTA_TXT:"Unlock SIM to device",
  MANAGE_SIM_DEVICE_UNLOCK_CTA_TXT:"Manage SIM to device",
  POP_CTA_TXT: 'Generate Port Out PIN',
  POP_CTA_GENERATED_TXT: 'Port Out PIN generated',
  PORT_OUT_PROTECTION_ON_STS_TXT: "Port Out Protection on",
  LOCK_SIM_TO_DEVICE_STS_TXT: "Lock SIM to Device ",
  SIM_PROTECTION_ON_STS_TXT: "SIM Protection on",
  CHANGE_RATE_PLAN: 'Change rate plan',
  STRATEGIC_PORT_IN_CTA_TXT: 'Strategic Port In',
  IS_INVOLUNTARY_SUSP: 'isInvoluntarySusp',
  IS_VOLUNTARY_SUSP: 'isVoluntarySusp',
  LINES_TAB_CLICK:'LinesBtnClick',
  PLAN_SERVICE_TAB_CLICK: 'PlanServicesBtnClick',
  USAGE_TAB_CLICK: 'UsageBtnClick',
  ACCOUNT_DETAILS_TAB_CLICK: 'AccDetailsBtnClick',
  LH_USER_NOTIFICTION_CONTACT_TAB_CLICK: 'LhNSettingsBtnClick',
  CHANGE_PLAN: 'Change plan',
  MOBILE_NUMBER: 'mobile-number',
  FORBIDDEN: 'Forbidden',
  CHANGE_NUMBER_REASON: 'reason',
  SHOW_CHARGE_ADVISEMENT_MSG_REASON_CODES: new Set([
    'CUSTEMPREQ',
    'CUSTEMPMOVED',
    'NEWUSER'
  ]),
  LINETYPE_VALUE: 'S',
  LINE_SUBTYPE_TDC: 'TDC',
  LINE_SUBTYPE_ML: 'ML',
  ANS_5G: '5G ANS',
  BUSINESS_INTERNET: 'BUSINESSINTERNET',
  ANS_5G_COLUMNS: {COLLAPSE:'', PRODUCT:'PRODUCT NAME', SUB_CATEGORY:'SUB-CATEGORY', FREQUENCY:'FREQUENCY', QUANTITY:'QUANTITY', UNIT_PRICE:'UNIT PRICE($)', RECURRING_CHARGE:'RECURRING CHARGE', STATUS:'STATUS'},
};

export const ALERT_POPUP_CONSTANTS: any = {
  TYPE: 'type',
  BUTTON_ROW: '.button-row',
  BOX_ICON: '.box_icon',
  NO_BUTTON: '.no-btn',
  OK_BUTTON: '.ok-btn',
};

export const SIM_CHANGE_CONST: any = {
  SWAPTYPE_ESIM: 'eSim',
  SWAPTYPE_SIM: 'Sim',
  SWAPTYPE_TO: ' to ',
  NEWSIM: 'New sim',
  REASON: 'Reason',
  ESIM_PSIM: 'eSIM / Physical SIM',
  ESIM : 'eSIM',
  PSIM : 'Physical SIM',
  SIM_SWAP_TXT: 'sim-swap',
  SUCCESS: 'SUCCESS',
  ACTIVE: 'ACTIVE',
  DISMISS_MODAL: 'dismiss modal',
  PHONE:'Phone',
  IMEI_LENGTH:15,
  PSIM_LENGTH:20,
  SIM_NUMBER_VALID: 'SIM Number Valid',
  SIM_NUMBER_INVALID: 'SIM Number Invalid',
  IMEI_INVALID: 'IMEI Number Invalid',
  IMEI_VALID: 'IMEI Number Valid',
  EID_INVALID: 'EID Number Invalid',
  EID_VALID: 'EID Number Valid',
  SIM_NUMBER_EXIST: 'SIM Number Exist',
  CONFIRM_SIM_NUMBER_MATCHES: 'SIM Number Matches',
  CONFIRM_SIM_NUMBER_NOT_MATCHES: 'SIM Numbers do not match',
  CONFIRM_EID_NUMBER_MATCHES: 'EID Number Matches',
  CONFIRM_EID_NUMBER_NOT_MATCHES: 'EID Numbers do not match',
  SIM_CHANGE_IMAGE : '/assets/tfb-acctmgmt/images/sim.jpg',
  ESIM_CHANGE_IMAGE : '/assets/tfb-acctmgmt/images/icons/eSimSwap.svg',
  PSIM_CHANGE_IMAGE : '/assets/tfb-acctmgmt/images/icons/pSimSwap.svg',
  REGEX19: /^8901([0-9]){15}$/,
  REGEX20: /^8901([0-9]){15}[fF]$/,
  REGEX21: /^\d{10}$/,
  REGEX_CHARACTER: /^[0-9]*$/,
  REMOVED_REASON_CODE: 'DO NOT USE-Fraud SIM Chng Corr',
  OLD_SIM: '[oldSim]',
  MSISDN: '[msisdn]',
  DUPLICATE_SIM: 'SIM Number Exist',
  DUPLICATE_EID:'EID Number Exist',
  PORTIN_TXT: 'port-in-change',
  NEW_SIM: 'newsim',
  CONFIRM_SIM: 'confirm',
  REGEX31: /^89([0-9]){30}$/,
  REGEX32: /^89([a-zA-Z0-9]){30}$/,
  REGEX15: /^([0-9]){15}$/,
  P_SIM_NUM_LENGTH: 19,
  E_SIM_NUM_LENGTH: 32,
  SUCCESS_EID_TXT: 'Success! ',
  EID_SUPPORTED : ' is supported.',
  PHONE_NOT_COMPATIBLE :' not compatible. Please try a physical SIM.',
  INVALID_SIM_ERROR : 'Invalid Field-newSim',
  ENTER_VALID_EID :'The EID you’ve entered is invalid. Please verify the EID number and try again.',
  SIM_NOT_VALID : 'The SIM is not in valid status',
  SIM_IN_USE : 'This SIM is already in use. To complete a SIM swap using a profile override, please contact our Business Team of Experts&reg; at 1-800-375-1126',
  VERIFY_EID : 'Verify the EID number.',
  UNKNOWN : 'UNKNOWN',
  INVALID_EID_ERROR : 'Invalid EID',
  SIM_IN_USE_ALT : 'This SIM is already in use. To complete a SIM swap using a profile override, please contact our Business Team of Experts at 1-800-375-1126',
};

export const MANAGE_MODAL_CONST: any = {
 DATE_FORMAT: 'MMMM d, y',
 DATE_FORMAT_FOR_CALL: 'yyyy-MM-dd',
 DATE_FORMAT_MM_DD_YYYY: 'MM/dd/yyyy',
 DATE_FORMAT_DD_MM_YYYY:'dd/MM/yyyy',
 DATE_CHECK_LIMIT: 10,
 AM: 'AM',
 PM: 'PM',
};

export const API_PARAMS_CONST: any = {
  CONTENT_HEADER_TYPE: 'application/x-www-form-urlencoded;charset=UTF-8',
 // B2B_ORG_ID: '7000000000000010162',
  B2B_CLIENT: 'TFB-AM-LH',
  B2B_CC_ID: 'ABCD',
  EUI_CLIENT_ID: 'TFBAccountManagement',
  EUI_CLIENT_ID_BILLING: 'TFBBilling',
  B2B_CLIENT_ID_TFB_AM_CARE: 'TFB-AM-CARE',
  B2B_CLIENT_ID_TFB_AM_APP: 'TFB-AM-APP',
};

export const CACHE_IGNORE_LIST: any = [
  { route: '/v1/oauth2/accesstoken?grant_type=client_credentials' },
  { route: '/b2b-experience/v1/billing-accounts' },
  { route: '/b2b-experience/v1/service-suspension-reasons' },
  { route: '/b2b-experience/v1/lines-of-service/' },
  { route: '/b2b-experience/v1/npa-nxx-lookup' },
  { route: '/b2b-experience/v1/service-suspension-approval-types' },
  { route: '/oauth2/'},
  { route: '/b2b-experience/v1/subscribers'},
  { route: '/resource-groups'},
  { route: '/b2b-experience/v1/b2b-billing-accounts/orgs/'},
  { route: '/b2b-experience/v1/b2b-billing-accounts/'},
  { route: '/b2b-experience/get-billing-accounts'},

];

export const CLONE_URL_IGNORE_LIST: any = [
  { route: '/v1/oauth2/accesstoken?grant_type=client_credentials' },
  { route: '.json' },
  { route: '/b2b-experience/v1/orgs/' },
  { route: '/wcs/resources/store/11151/user/login' },
  { route: '/b2b-experience/v1/services' },
  { route: '/oauth2/'},
  { route: '/b2b-experience/v1/entitlements/orgs'},
  { route: '/b2b-experience/v1/b2b-billing-accounts/line-identifier-update-eligibility'},
  { route: '/resource-groups'},
  { route: '/b2b-experience/v1/b2b-billing-accounts/orgs/'},
  { route: '/b2b-experience/v1/bulk/bulkprocessor'},
  { route: '/b2b-experience/v1/subscribers'},
  { route: '/b2b-experience/v2/line-upgrade-eligibility-profiles'},
  { route: '/customer-loan/v1/loan-histories'},
  { route: '/billing/v1/invoices'},
  { route: '/usage/v1/lines-of-service'},
  { route: '/billing/v1/accountbills'},
  { route: '/tms/v3/usertoken'},
  { route: '/usage/v1/financial-accounts/'}
];

export const LOADER_IGNORE_LIST: any = [
  { route: '/b2b-experience/v1/orgs/'},
  { route: '/b2b-experience/v1/billing-accounts/'},
  { route: '/b2b-experience/v1/entitlements/orgs'},
  { route: '/splunk-logs/services/collector/event' },
  // { route: '/b2b-experience/v1/b2b-billing-accounts' }
];

export const LOGGING_URL_IGNORE_LIST: any = [
  { route: '/b2b-experience/v1/content?service=/tmobile/cq/authorvalue/content/coe/en/account-management-authoring.json' },
  { route: '/tmobile/cq/loggingapi' },
  { route: '/splunk-logs/services/collector/event' },
];

export const IMAGES_URL: any = {
};

export const TOKEN_DEFAULTS: any = {
  RETRY_INTERVAL: 120000,
  SET_TIME: 2000000,
};
export const ALL_TRANSACTION_TYPES = {
  SUSPEND: 'suspendServiceList',
  CHANGE_MSISDN: 'changeMSISDNList',
  RESTORE: 'restoreServiceList',
  SIM_SWAP: 'simSwapList',
  BAN_AUTO_ENROLL: 'banAutoEnrollList',
  BAN_AUTO_UPDATE_ENROLL: 'banAutoUpdateEnrollList',
  BAN_AUTO_UNENROLL: 'banAutoUnEnrollList',
  PAPERLESS_ENROLL: 'paperLessEnrollList',
  PAPERLESS_UPDATE_ENROLL: 'paperLessUpdateEnrollList',
  PAPERLESS_UNENROLL: 'paperLessUnEnrollList',
  CHANGE_SOC: 'changeLineSocList',
  PORT_IN: 'portInChangeList',
  LINE_IDENTIFIER_UPDATE: 'lineIdentifierUpdateList',
  PAPERLESS_BILLING_ENROLL: 'PAPERLESS_BILLING_ENROLL',
  ONE_TIME_PAYMENT: 'onetimePaymentList',
  SCHEDULED_PAYMENT: 'scheduledPaymentList',
  CANCEL_SCHEDULE_PAYMENT: 'cancelScheduledPaymentList',
  CANCEL_SUBSCRIBER:'cancelSubscriberList',
  EIP_STANDALONE_PAYMENT:'eipLoanPaymentList',
  MANAGE_PAIRING:'managePairingList',   
  TPOP_CANCEL:'tpopCancellationList',
  TPOP_GENERATE:'tpopGenerationList',
  STRATEGIC_PORT_IN:'strategicPortInList',
  PORT_OUT_BLOCK_UNBLOCK:'managePortOutList',
  SIM_PROTECTION:'manageSimswapBlockList',
  SIM_TO_DEVICE_LOCK_UNLOCK:'manageSimToDeviceList'
};

export const ALL_TRANSACTION_TYPES_CONST = {
  PORT_IN: 'PORT_IN',
  COLUMNS: {
    COL_PREVIOUS_NUMBER : 'Previous Number',
    COL_REQUEST_DATE : 'Request Date',
  },
  DATE_FORMAT: 'MM/dd/yyyy',
};

export const TRANSACTION_HISTORY_DETAILS_CONSTANTS: any = {
  DEFAULT_PAGE_SIZE: '100',
  TRANSACTION_TYPE: {
    MOBILE_NUMBER_CHANGE: 'Mobile Number Change',
    SIMSWAP: 'SimSwap Request',
    RESTORE: 'Restore Service',
    SUSPEND: 'Suspend Service',
    PORT_IN: 'CHANGE_MSISDN_PORTIN',
    CHANGE_SERVICES: 'Line SOC Change',
    LINE_ID_UPDATE_REQUEST :'Line Identifier Update Request',
    DELETE_SCHEDULED_PAYMENT_REQUEST:'Delete Scheduled Payment Request',
    BILL_PAYMENT_REQUEST:'Bill Payment Request',
    SCHEDULED_PAYMENT_REQUEST:'Scheduled Payment Request',
    DELETE_PAYMENT_AGREEMENT_REQUEST:'Delete Payment Agreement Request',
    CREATE_PAYMENT_ARRANGEMENT:'Create Payment Arrangement Request',
    EDIT_PAYMENT_ARRANGEMENT:'Edit Payment Arrangement Request',
  },
  DEALER_CODE: "Dealer Code",
  RESPONSE_STATUS: "Response status"
};

export const BULK_UPLOAD = {
  COL_DEF_DATE_TODAY: 'dateToday',
  COL_HEADER_START_DATE_TODAY: 'Suspend_start_date_today',
  BULK_OR_INLINE_FLOW: 'bulk-or-inline-flow',
  CHANGE_PHONE_KEY: 'change-phone',
  SIM_SWAP_KEY: 'sim-swap',
  SUSPEND_KEY: 'suspend',
  RESTORE_KEY: 'restore',
  UPDATE_LINE_IDENTIFIER: 'update-line-identifier',
  TRANSFER_NUMBERS: 'transfer-numbers',
  TRANSACTION_HISTORY:'strategic-port-in-transactions',
  LINE_IDENTIFIER: 'line-indentifier',
  BULK_UPLOAD_REQUEST_KEY : 'bulk_upload_request',
  SUSPEND_SERVICE_TXT : 'suspend-service',
  BULK_FLOW_KEY: 'bulk-flow',
  TPOP_KEY: 'tpop',
  IS_ACTIVE_SELECTED: 'isActiveChbxSelected',
  TEMPLATE_KEY : 'template',
  XLSX_TXT: 'xlsx',
  CSV_TXT: 'csv',
  ERROR_MSG: 'errorMsg',
  BANLISTNG_TOP_BLKUPLD: 'banListingTopBlkUpld',
  RESTORE_SUCCESS_DATA: 'restore-success-data',
  BULK_TEMPLATE_CHANGEMSISDN : 'BulkTemplate_ChangeMSISDN',
  BULK_TEMPLATE_SUSPEND : 'BulkTemplate_Suspend',
  BULK_TEMPLATE_RESTORE : 'BulkTemplate_Restore',
  BULK_TEMPLATE_TRANSFERNUMBER : 'BulkTemplate_TransferNumbers',
  BULK_TEMPLATE_LINEIDENTIFIER: 'BulkTemplate_LineIdentifiers',
  BULK_TEMPLATE_SIM_SWAP : 'BulkTemplate_SimSwap',
  BULK_TEMPLATE_ESIM_SWAP : 'BulkTemplate_ESimSwap',
  BULK_TEMPLATE_CHANGE_SERVICE: 'BulkTemplate_ChangeService',
  BULK_TEMPLATE_MANAGEPAIRING:'BulkTemplate_ManagePairing',
  BULK_TEMPLATE_STRATEGIC_PORT_IN:'BulkTemplate_StrategicPortIn',
  BULK_TEMPLATE_TPOP:'BulkTemplate_GenerateTPOP',
  SIM_SWAP_NOTE: 'Both Phone Number and old SIM number are required to assign a New Physical SIM or eSIM.',
  ESIM_SWAP_NOTE: 'Both Phone Number and old SIM number are required to assign a New Physical SIM or eSIM.',
  SUSPEND_NOTE : 'TEST TEXT',
  BULK_SUSPEND_APPROVE_TEXT: 'Suspend_ApproverType',
  BULK_SUSPEND_APPROVER_TXT : 'Suspend_ApproverType(not required for Lost/Stolen, Seasonal suspend, or Retention suspend)',
  SIM_SWAP_SUCCESS_DOWNLOAD: 'BulkTemplate_SimSwap_Bydefault_updated',
  ESIM_SWAP_SUCCESS_DOWNLOAD: 'BulkTemplate_ESimSwap_Bydefault_updated',
  SUSPEND_SUCCESS_DOWNLOAD: 'BulkTemplate_Suspend_Bydefault_updated',
  RESTORE_SUCCESS_DOWNLOAD: 'BulkTemplate_Restore_Bydefault_updated',
  CHANGE_NUMBER_SUCCESS_DOWNLOAD: 'BulkTemplate_ChangeMSISDN_Bydefault_updated',
  TRANSFER_NUMBER_SUCCESS_DOWNLOAD: 'BulkTemplate_TransferNumber_Bydefault_updated',
  BULK_PORTIN_SUCCESS_DOWNLOAD : 'BulkNumberTransfer',
  TRANSFER_NUMBER_ERROR_DOWNLOAD: 'BulkTemplate_TransferNumber_Bydefault_updated',
  CHANGE_NUMBER_ERROR_DOWNLOAD: 'BulkTemplate_ChangeMSISDN_Bydefault_updated',
  ACCOUNT_LISTING_DOWNLOAD: 'MSISDN_List',
  SUSPEND_ERROR_DOWNLOAD: 'BulkTemplate_Suspend_Bydefault_updated',
  BULK_SUSPEND_STARTDATE_TXT : 'Suspend_start_date',
  SIM_SWAP_ERROR_DOWNLOAD: 'BulkTemplate_SimSwap_Bydefault_updated',
  ESIM_SWAP_ERROR_DOWNLOAD: 'BulkTemplate_ESimSwap_Bydefault_updated',
  BULK_SUSPEND_ENDDATE_TXT : 'Suspend_end_date',
  BULK_SUSPEND_REASON_TXT : 'Suspend_reason',
  SUSPEND_MSISDN : 'msisdn',
  SUSPEND_REASONCODE : 'reasonCode',
  SUSPEND_VALIDATORTYPE : 'validatorType',
  SUSPEND_STARTDATE : 'suspendStartDate',
  SUSPEND_ENDDATE : 'restoreDate',
  SUSPEND_ERR_MSG : 'errorMsg',
  BULK_PHONE_NUMBER_TXT : 'PhoneNumber',
  BULK_ACCOUNT_NUMBER_TXT : 'AccountNumber',
  CHANGE_NUMBER_REASON_FOR_CHANGE_TXT: 'Reason_For_Change',
  FAILEDROWS_LENGTH_TXT : 'failed_rows',
  BULK_UPLOAD_RESTORE_DATE : 'RestoreDate',
  BULK_SIMSWAP_OLDSIM_Txt: 'OldSim',
  BULK_SIMSWAP_EID_Txt: 'EID (for eSIM)',
  BULK_ESIMSWAP_NEWSIM_Txt: 'NewSIM (for Physical SIM)',
  BULK_SIMSWAP_NEWSIM_Txt: 'NewSim',
  BULK_SIMSWAP_REASON_FOR_CHANGE_Txt: 'Reason_For_Change',
  NUMBER: 'number',
  DATE: 'date',
  BAN: 'ban',
  SUSPNDREASN_SEASONAL_TXT: 'Seasonal Suspend',
  SUSPNDREASN_LOST_TXT: 'Lost/Stolen Suspend',
  LOSTSTOLEN_TXT: 'loststolen',
  SUSPNDREASN_TEMP_TXT: 'Temporary Suspend',
  TEMPSUSPND_RANGE_TXT: 'tempsuspendrange',
  SUSPNDREASN_RESELLWITHOUT_TXT: 'Reseller Suspend without charges',
  SUSPNDREASN_RESELLWITH_TXT: 'Reseller Suspend with charges',
  RESELL_RANGE_TXT: 'resellerrange',
  PREFERRED_AREA_CODE: 'Preferred_Area_Code',
  SUSPEND_FLOW_DATA: 'suspendData',
  SUSPEND_OBJECT_KEYS: ['PhoneNumber', 'Suspend_reason',
  'Suspend_ApproverType(not required for Lost/Stolen, Seasonal suspend, or Retention suspend)', 'Suspend_end_date', 'Suspend_start_date'],
  SUSPEND_SHEET_KEYS: ['PhoneNumber', 'Suspend_reason', 'Suspend_ApproverType(not required for Lost/Stolen, Seasonal suspend, or Retention suspend)', 'Suspend_start_date', 'Suspend_end_date', '*Note: Special Unlimited suspension type is only available for specific Business and Government accounts listed in the C2 and the Business & Government contracts database. Do not use this suspension type on non-approved accounts.'],
  SUSPEND_SHEET_KEYS_IAM: ['PhoneNumber', 'Suspend_reason', 'Suspend_ApproverType(not required for Lost/Stolen or Seasonal suspend)', 'Suspend_start_date', 'Suspend_end_date'],
  RESTORE_SHEET_KEYS: ['PhoneNumber', 'RestoreDate' ,
  '*Note: If the line being restored has been suspended using temporary suspend reason code, retention suspend or reseller suspend reason code(RSS or RSQ) the effective restore date should be set to current date'],
  CHANGE_NUMBER_SHEET_KEYS: ['PhoneNumber', 'Preferred_Area_Code', 'Reason_For_Change'],
  SIM_CHANGE_SHEET_KEYS: ['PhoneNumber' , 'OldSim' , 'NewSim' , 'Reason_For_Change' , 'Note: Both Phone Number and old SIM number are required to assign a New Physical SIM or eSIM.'],
  ESIM_CHANGE_SHEET_KEYS: ['PhoneNumber' , 'OldSim' , 'EID (for eSIM)' , 'NewSIM (for Physical SIM)' , 'Reason_For_Change' , 'Note: Both Phone Number and old SIM number are required to assign a New Physical SIM or eSIM.'],
  TRANSFER_NUMBER_SHEET_KEYS: ['T-Mobile MSISDN' , 'Number to transfer' , 'Carrier account number' , 'Account Pin or Password (optional)' , 'Port Date (MM/DD/YYYY)' , 'Port Start Time (PST) (HR:MIN:SS AM/PM) (optional)'],
  LINE_IDENTIFIER_SHEET_KEYS: ['BAN', 'PhoneNumber'],
  CANCEL_SUBSCRIBER_KEYS: ['PhoneNumber', 'Cancel_date', 'Cancel_reason'],
  TPOP_BULK_KEYS: ['AccountNumber', 'PhoneNumber'],
  SHEET_NAME: 'TransferNumbers_Data',
  MSISDN_NUMBER_TXT: 'T-Mobile MSISDN',
  NUMBER_TO_TRANSFER_TXT: 'Number to transfer',
  PORT_DATE_TXT: 'Port Date (MM/DD/YYYY)',
  PORT_TIME_TXT: 'Port Time (HR:MIN:SS AM/PM)',
  PORT_START_TIME_TXT: 'Port Start Time (PST) (HR:MIN:SS AM/PM) (optional)',
  RESULT_TXT: 'Result',
  CARRIER_ACCOUNT_NUMBER: 'Carrier account number',
  ACCOUNT_PIN_OR_PASSWORD: 'Account Pin or Password (optional)',
  TRANSFER_NUMBER_SUCCESS_KEY: 'transferNumberValidRecords',
  DUPLICATE_NUMBER_TXT: 'Duplicate MSISDN',
  TIME_FORMAT_REGEX: /^[01]?\d:[0-5]\d:[0-5]\d( (am|pm))?$/i,
  ERROR_KEY: 'Error',
  INVALID_NUMBER_TO_TRANSFER_ERR_KEY: 'invalidTransferErrMsg',
  DUPLICATE_NUMBER_TO_TRANSFER_ERR_KEY: 'duplicateNumberErrMsg',
  SAME_AS_MSISDN_ERR_KEY: 'sameAsMSISDNErrMsg',
  INVALID_ACCOUNT_NUMBER_ERR_KEY: 'invalidAccountNumberErrMsg',
  MISSING_ACCOUNT_NUMBER_ERR_KEY: 'missingAccountNumberErrMsg',
  INVALID_PORT_DATE_ERR_KEY: 'invalidPortDateErrMsg',
  MISSING_PORT_DATE_ERR_KEY: 'missingPortDateErrMsg',
  INVALID_PORT_TIME_ERR_KEY: 'invalidPortTimeErrMsg',
  MISSING_PORT_TIME_ERR_KEY: 'missingPortTimeErrMsg',
  EXCEL_ERROR_MSG: {
    MISSING_INVALID_MSISDN: 'Missing or invalid phone number',
    MISSING_INVALID_NUMBER_TO_TRANSFER: 'Missing or invalid Number to transfer',
    DUPLICATE_PHONE_NUMBER_ERR_MSG: 'Duplicate Phone number data submitted. Please remove duplicate data and try again.',
    MISSING_CARRIER_ACCOUNT_NUMBER: 'Missing Carrier account number',
    INVALID_CARRIER_ACCOUNT_NUMBER: 'Invalid Carrier account number',
    MISSING_PORT_DATE: 'Missing Port Date',
    INVALID_PORT_DATE: 'Invalid Port Date',
    MISSING_PORT_TIME: 'Missing Port Time',
    INVALID_PORT_TIME: 'Invalid Port Time',
    NUMBER_TO_TRANSFER_NOT_BE_SAME_AS_MSISDN: 'Number to transfer cannot be same as T-Mobile MSISDN',
    MISSING_PREFERRED_AREA_CODE: 'Missing preferred code',
    INVALID_PREFERRED_AREA_CODE: 'Invalid preferred code',
    MISSING_PHONE_NUMBER_TXT: 'Missing phone number',
    INVALID_PHONE_NUMBER_TXT: 'Invalid phone number',
    MISSING_BULK_SIMSWAP_REASON_FOR_CHANGE: 'Missing reason for change',
    INVALID_BULK_SIMSWAP_REASON_FOR_CHANGE: 'Invalid reason for change',
    MISSING_BULK_SIMSWAP_OLDSIM: 'Missing oldsim number',
    INVALID_BULK_SIMSWAP_OLDSIM: 'Invalid oldsim number',
    MISSING_BULK_SIMSWAP_EID: 'Missing eid number',
    INVALID_BULK_SIMSWAP_EID: 'Invalid eid number',
    MISSING_BULK_SIMSWAP_NEWSIM: 'Missing newsim number',
    INVALID_BULK_SIMSWAP_NEWSIM: 'Invalid newsim number',
    DELETE_EID_NEWSIM: 'Delete eid number / Delete newsim number'
  },
  TRANSFER_NUMBERS_ISSUES_FOUND_KEY: 'transfer-numbers-issues-found',
  CUSTOMER_SIM_SIM_IN_KIT: 'Customer SIM/SIM in Kit',
  CUSTOMER_EMPLOYEE_REQUEST: 'Customer/Employee Request',
  VALIDATED_DEFECTIVE_SIM: 'Validated Defective SIM',
  LOST_STOLEN_DAMAGED_SIM: 'Lost/Stolen/Damaged SIM',
  SIM_CHANGE_REASON_BYOS: 'BYOS',
  SIM_CHANGE_REASON_CR: 'CR',
  SIM_CHANGE_REASON_DFS: 'DFS',
  SIM_CHANGE_REASON_LS: 'LS',

  PHONE_NUMBER_TXT: 'PhoneNumber',
  BAN_TXT: 'Ban',
  STATUS_TXT: 'Status',
  LINE_TXT: 'Line',
  TYPE_TXT: 'Type',
  CURRENT_TXT: 'Current',
  UPDATED_TXT: 'Updated',
  PHONE_TXT: 'Phone',
  MOBILE_INTERNET_TXT: 'Mobile internet',
  PRODUCT_TYPE_G : 'G',
  PRODUCT_TYPE_GSM : 'GSM',
  PRODUCT_TYPE_B : 'B',
  PRODUCT_TYPE_MI: 'MI',
  LINE_TYPE_V: 'V',
  LINE_TYPE_D: 'D',
  CANCEL_SUBSCRIBER: 'cancel-subscriber',
  CHANGE_SERVICE: 'change-service',
  CANCEL_DATE: 'Cancel_date',
  CANCEL_REASON: 'Cancel_reason',
  MANAGE_PAIRING: 'manage-pairing',

  CANCEL_SUBSCRIBER_ERROR_DOWNLOAD: 'BulkTemplate_CancelSubscriber_Bydefault_updated',
  CHANGE_SERVICE_ERROR_DOWNLOAD: 'BulkTemplate_ChangeService_Bydefault_updated',
  SELECTED_BAN_MSISDNS: 'selectedBanMsisdns',
  CATALOG_SERVICE_AGGREGATION_RESP: 'catalogServiceResponse',
  CATALOG_SERVICES: 'catalogServices',

  MNG_PAIRING_MOBILE_LINE: 'Voice_Line',
  MNG_PAIRING_DIGITS_LINE: 'Watch_Line',
  MNG_PAIRING_ACTION: 'Action',
  MANAGE_PAIRING_KEYS: ['Voice_Line', 'Watch_Line', 'Action'],
  MANAGE_PAIRING_ACTIONS: ['PAIR', 'UNPAIR'],
  BULK_TEMPLATE_MANAGE_PAIRING: 'BulkTemplate_ManagePairing',
  MANAGE_PAIRING_ERROR_DOWNLOAD: 'ManagePairing_Errors',

  STRATEGIC_PORT_IN: 'strategic-port-in',
  STRATEGIC_PORT_IN_KEYS: ['T-Mobile MSISDN', 'Number to transfer', 'Carrier account number', 'Account Pin or Password'],
  STRATEGIC_PORT_IN_TMO_MSISDN: 'T-Mobile MSISDN',
  STRATEGIC_PORT_IN_TEMP_MSISDN: 'Number to transfer',
  STRATEGIC_PORT_IN_CARRIER_ACC_NUM: 'Carrier account number',
  STRATEGIC_PORT_IN_ACC_PIN: 'Account Pin or Password',
  STRATEGIC_PORT_IN_ERROR_DOWNLOAD: 'StrategicPortIn_Errors',
  CONFIG_KEY_STRATEGIC_PORT_IN_ORG: 'enableStrategicPortin',
  STRATEGIC_PORT_IN_REMOVED_PIN_TXT: 'REMOVED DATA'
};

export const EXCEL_JS = {
  ERROR_STYLE: 'error',
  CELL_A: 'A',
  CELL_B: 'B',
  CELL_C: 'C',
  CELL_D: 'D',
  CELL_E: 'E',
  CELL_F: 'F',
  CELL_G: 'G',
  CELL_H: 'H',
  CELL_I: 'I',
  CELL_J: 'J',
  CELL_K: 'K',
  CELL_L: 'L',
  CELL_M: 'M',
  CELL_N: 'N',
  CELL_O: 'O',
  CELL_P: 'P',
  CELL_Q: 'Q',
  CELL_R: 'R',
  CELL_S: 'S',
  CELL_T: 'T',
  CELL_U: 'U',
  CELL_V: 'V',
  CELL_W: 'W',
  CELL_X: 'X',
  CELL_A1: 'A1',
  CELL_A2: 'A2',
  CUSTOM: 'custom',
  VISIBLE: 'visible',
  SHEET_NAME_DATA: 'data',
  TIME_FORMAT_1: '12:00:00',
  TIME_FORMAT_2: '11:59:59',
  FROZEN_STATE: 'frozen',
  VALIDATION_TYPE_WHOLE: 'whole',
  VALIDATION_TYPE_LIST: 'list',
  VALIDATION_TYPE_DATE: 'date',
  VALIDATION_TYPE_TIME: 'time',
  VALIDATION_TYPE_TEXT_LENGTH: 'textLength',
  OPERATOR_BETWEEN: 'between',
  OPERATOR_EQUAL: 'equal',
  NUMBER_FORMAT: '(###) ###-####',
  NUMBER_FORMAT_V2: '###-###-####',
  NUMBER_FORMAT_V3: '#########',
  TEXT_FORMAT: '@',
  DATE_FORMAT: 'mm/dd/yyyy',
  TIME_FORMAT: 'h:mm:ss AM/PM',
  NOTE_SIM_SWAP : 'Note: Both Phone Number and old SIM number are required to assign a New Physical SIM or eSIM.',
  NOTE_ESIM_SWAP : 'Note: Both Phone Number and old SIM number are required to assign a New Physical SIM or eSIM.',

  CHANGE_MSISDN_SHEET: 'ChangeMsisdn_Data',
  TRANSFER_NUMBER_SHEET: 'TransferNumbers_Data',
  RESTORE_SHEET: 'Restore_Data',
  SUSPEND_SHEET: 'SuspendData',
  RESEND_SHEET:'resendData',
  SIMSWAP_SHEET: 'SimSwap_Data',
  CHANGE_SERVICE_SHEET: ' ChangeService_Data',
  LINE_IDENTIFIER_SHEET: 'LineIdentifier_Data',
  MANAGE_PAIRING_SHEET: 'ManagePairing_Data',
  STRATEGIC_PORT_IN_SHEET: 'StrategicPortIn_Data',
  HIDDEN_SHEET: 'hiddenSheet',
  TPOP_SHEET: 'TPOP_Data',

  ERROR_FORMAT_TEN_DIGITS: 'Only numbers eg. XXXXXXXXXX',
  ERROR_FORMAT_FOR_MSISDN: 'Please enter 10 digit msisdn',
  ERROR_FORMAT_THIRTY_CHAR: '1/30 ( min / max & special characters included )',
  ERROR_FORMAT_DATE: 'Format (MM/DD/YYYY)',
  ERROR_FORMAT_TIME: 'Format (HR:MIN:SS AM/PM). The cell must contain a time between 12:00:00 AM and 11:59:59 PM.',

  PROMPT_FORMAT_TEN_DIGITS: 'eg. XXXXXXXXXX',
  PROMPT_FORMAT_THIRTY_CHAR: '1/30 ( min / max & special characters included )',
  PROMPT_FORMAT_DATE: 'Format  (MM/DD/YYYY)',
  PROMPT_FORMAT_TIME: 'Format (HR:MIN:SS AM/PM)',

  PROMPT_FORMAT_NINE_DIGITS: 'eg. XXXXXXXXX',
  ERROR_FORMAT_NINE_DIGITS: 'Only numbers eg. XXXXXXXXX',

  ERROR_TITLE_MSISDN: 'T-mobile MSISDN',
  ERROR_TITLE_INVALID_MSISDN: 'Invalid Msisdn',
  ERROR_TITLE_CARRIER_NUMBER: 'Carrier account number',
  ERROR_TITLE_PIN_PASSWORD: 'Account Pin or Password',
  ERROR_TITLE_PORT_DATE: 'Port Date ',
  ERROR_TITLE_PORT_TIME: 'Port Time ',

  PROMPT_TITLE_MSISDN: 'T-mobile MSISDN - 10 digits',
  PROMPT_TITLE_TRANSFER_NUMBER: 'Number to transfer - 10 digits ',
  PROMPT_TITLE_CARRIER_NUMBER: 'Carrier account number',
  PROMPT_TITLE_PIN_PASSWORD: 'Account Pin or Password',
  PROMPT_TITLE_PORT_DATE: 'Port Date ',
  PROMPT_TITLE_PORT_TIME: 'Port Time ',

  ERROR_TITLE_AREA_CODE: 'Invalid Area Code',
  ERROR_TITLE_INVALID_VALUE: 'Invalid value',
  ERROR_TITLE_PHONE_NUMBER: 'Invalid Phone Number Format',
  ERROR_TITLE_ACCOUNT_NUMBER: 'Invalid Account Number Format',

  ERROR_AREA_CODE: 'Excpected Format : XXX',
  ERROR_TITLE_PHONENUMBER : 'Phone Number',
  ERROR_TITLE_ACCOUNTNUMBER : 'Account Number',
  PROMPT_SUSPENDED_APPROVE_TYPE: 'Suspend approve type',
  PROMPT_TITLE_SUSPEND_START_DATE : 'Suspend start date',
  PROMPT_TITLE_SUSPEND_END_DATE : 'Suspend end date',
  PROMPT_TITLE_SUSPEND_REASON : 'Invalid reason',
  ERROR_FIELD_NOT_EMPTY: 'This field cannot be empty',

  PROMPT_FORMAT_AREA_CODE: 'Excpected Format : XXX',
  PROMPT_FORMAT_REASON_FOR_CHANGE: 'Please enter a value from the drop down list.',

  PROMPT_TITLE_AREA_CODE: 'Area Code - 3 digits',
  PROMPT_TITLE_REASON_FOR_CHANGE: 'Reason for Change',
  PROMPT_TITLE_REASON_FOR_CANCELLATION: 'Reason for Cancellation',
  PROMPT_TITLE_SUSPEND_REASON_DROPDOWN: 'Suspend Reason',
  PROMPT_TITLE_SUSPEND_APPROVER_TYPE_DROPDOWN: 'Suspend Approver Type',
  PROMPT_TITLE_PHONE_NUMBER: 'Phone Number - 10 digits',
  PROMPT_TITLE_ACCOUNT_NUMBER: 'Account Number - 9 digits',
  DROPDOWN_VALUES_REASON_FOR_CHANGE: '"Customer/Employee moved, Customer/Employee request, Harassing phone calls, Incorrect area code/prefix, New user"',
  DROPDOWN_VALUES_SUSPEND_REASON : '"Lost/Stolen_Suspend, Seasonal_Suspend,Temporary_Suspend, Reseller_Suspend_without_charges, Reseller_Suspend_with_charges, Implementation_Suspend, MCSA_Contractual_Suspend, Special_Unlimited_Suspend, Retention_Suspend_(Gov_Only)"',
  DROPDOWN_VALUES_SUSPEND_REASON_ACC_TYPE_G : '"Lost/Stolen_Suspend, Seasonal_Suspend,Temporary_Suspend, Reseller_Suspend_without_charges, Reseller_Suspend_with_charges, Education_Summer_Suspend, Implementation_Suspend, MCSA_Contractual_Suspend, Special_Unlimited_Suspend, Retention_Suspend_(Gov_Only)"',
  DROPDOWN_VALUES_SUSPEND_REASON_IAM : '"Lost/Stolen_Suspend,  Seasonal_Suspend"',
  DROPDOWN_VALUES_SIM_SWAP_DROPDOWN : '"Lost/Stolen/Damaged SIM, Customer SIM/SIM in Kit, Customer/Employee Request, Validated Defective SIM"',
  DROPDOWN_VALUES_SUSPEND_APPROVE_TYPE : '"SENIOR MANAGER, DIRECTOR, VP, SALES REP INITIATED, B2B MARKETING MANAGER, SALES DIRECTOR, CUSTOMER INITIATED, DIRECTOR AND VP, SALES VP AND QA TEAM"',
  DROPDOWN_VALUES_CHANGE_SERVICE: '"Add, Remove"',
  DROPDOWN_VALUES_CANCEL_SUBSCRIBER: '"Billing problems, Coverage Issues, Lost or Stolen equipment, Low Usage, No Longer an Employee"',
  APPLICATION_FORMAT_TYPE: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',

  ERROR_FORMAT_TEN_DIGITS_RESTORE_KEY: 'Please enter a phone number in a valid format. Expected format: XXXXXXXXXX : a 10 digit number',
  PROMPT_TITLE__RESTORE_KEY: 'Restore Date',
  ERROR_TITLE_RESTORE_KEY: 'Invalid date',
  ERROR_RESTORE_KEY: 'Please enter a valid date. Expected format: MM/DD/YYYY. Expected value: Either today or a future date is expected.',

  RESTORE_KEY_NOTE: '*Note: If the line being restored has been suspended using temporary suspend reason code, retention suspend or reseller suspend reason code(RSS or RSQ) the effective restore date should be set to current date',
  SUSPEND_KEY_NOTE: '*Note: Special Unlimited suspension type is only available for specific Business and Government accounts listed in the C2 and the Business & Government contracts database. Do not use this suspension type on non-approved accounts.',
  SUSPEND_KEY_NOTE_2: '*Note: Restore date is not applicable when using the Lost or Stolen reason code.',
  PROMPT_TITLE_RESTORE_KEY_NOTE: 'Date',

  PROMPT_TITLE_SIMSWAP_KEY: 'Old Sim',
  PROMPT_TITLE_SIMSWAP_NEW_KEY: 'New Sim',
  PROMPT_TITLE_SIMSWAP_EID_KEY: 'EID',
  PROMPT_SIMSWAP_KEY: '19 digits+alphanumeric',
  PROMPT_ESIMSWAP_KEY: '32 digits or 32 alphanumeric characters',
  ERROR_TITLE_SIMSWAP_KEY: 'Invalid value',
  ERROR_SIMSWAP_KEY: 'Please enter a proper value. Expected Format: 8901XXXXXXXXXXXXXXXF : 19 digits+alphanumeric',
  ERROR_ESIMSWAP_KEY: 'Please enter a proper value. Expected Format: 89XXXXXXXXXXXXXXXXXXXXXXXXXXXXXX : 32 digits or 32 alphanumeric characters',

  ORGANISATION_NAME_TXT: 'Organization Name',
  ERROR_TITLE_INALID_PHONE_NUMBER: 'Invalid Phone Number Format',
  ERROR_INVALID_PHONE_NUMBER: 'Please enter a phone number in a valid format. Expected format: XXXXXXXXXX: a 10 digit number.',
  ERROR_TITLE_INVALID_BAN: 'Invalid Ban Format',
  ERROR_INVALID_BAN: 'Please enter a ban in a valid format. Expected format: XXXXXXXXX: a 9 digit number.',
  ERROR_INVALID_ACC_NUM: 'Please enter an account number in a valid format. Expected format: XXXXXXXXX: a 9 digit number.',
  ERROR_TITLE_INVALID_UDF: 'Invalid Text',
  ERROR_INVALID_UDF: 'Please enter a valid text. Maximum length should be 80 characters and should not contain following special characters +,*,=,%,^,<,>,{,},[,],",\'',

  PROMPT_TITLE_CANCEL_SUBSCRIBER_START_DATE: 'Cancel start date',
  ERROR_BAN_MSISDN_MISMATCH: 'Only Phone Numbers pertaining to this Ban are allowed',
  ERROR_BAN_VOICE_MISMATCH: 'Only Voice lines pertaining to this Ban are allowed',
  ERROR_BAN_DIGITS_MISMATCH: 'Only Watch lines pertaining to this Ban are allowed',
  ERROR_CHANGE_SERVICES_INVALID_INPUT: 'Only acceptable values are "", "Add", "Remove"',

  ERROR_MANAGE_PAIRING_INVALID_ACTION: 'Only acceptable action values are "PAIR" or "UNPAIR"',
  ERROR_INVALID_VOICE_NUMBER: 'Please enter a voice line in a valid format. Expected format: XXXXXXXXXX: a 10 digit number.',
  ERROR_INVALID_DIGITs_NUMBER: 'Please enter a watch line in a valid format. Expected format: XXXXXXXXXX: a 10 digit number.',
  PROMPT_TITLE_MOBILE_LINE: 'Voice Line - 10 digits',
  ERROR_TITLE_MOBILE_LINE: 'Voice Line',
  PROMPT_TITLE_DIGITS_LINE: 'Watch Line - 10 digits',
  ERROR_TITLE_DIGITS_LINE: 'Watch Line',
  DROPDOWN_VALUES_MANAGE_PAIRING: '"PAIR, UNPAIR"',
  PROMPT_TITLE_ACTION: 'Action',
  PROMPT_SELECT_ACTION: 'Please select an action',
  PROMPT_INVALID_ACTION_TITLE: 'Error',
  PROMPT_INVALID_ACTION: 'Invalid action',

  ERROR_INVALID_CARRIER_ACC_NUM: 'Carrier account number is a required field between 1 and 30 characters',
  ERROR_INVALID_ACC_PIN_PASSWORD: 'Account Pin/Password number is a required field between 1 and 30 characters',

  ERROR_PORTIN_MSISDN_ALREADY_IN_REQUEST: 'Number to transfer is already being used in another request inside this file',
  ERROR_TMO_TEMP_MSISDN_ALREADY_IN_REQUEST: 'T-Mobile MSISDN is already being used in another request inside this file',
};

export const VALUE = {
    ZERO: 0,
    ONE: 1,
    TWO: 2,
    THREE: 3,
    FOUR: 4,
    FIVE: 5,
    SIX: 6,
    ELEVEN: 11,
    FIFTEEN: 15,
    SIXTEEN: 16,
    SEVENTEEN: 17,
    NINETEEN: 19,
    TWENTY_ONE: 21,
    TWENTY_THREE: 23,
    TWENTY_FOUR: 24,
    TWENTY_SEVEN: 27,
    THIRTY_ONE: 31,
    THIRTY_TWO: 32,
    THIRTY_FIVE: 35,
    MINUS_ONE: -1,
    TEN: 10,
    THIRTEEN: 13,
    TWENTY: 20,
    THIRTY: 30,
    FIFTY: 50,
    FIFTY_FIVE: 55,
    SIXTY: 60,
    SIXTY_FOUR: 64,
    SEVENTY : 70,
    NINETY: 90,
    HUNDRED: 100,
    HUNDRED_TEN: 110,
    HUNDRED_TWENTY_FIVE: 125,
    TRIPPLE_NINE: 999,
    TWO_THOUSAND_ONE: 2001,
    TWO_THOUSAND_FIVE_HUNDRED_ONE: 2501,
    POINT_THREE: 0.3,
    POINT_SEVEN: 0.7,
    POINT_SEVEN_FIVE: 0.75,
    THOUSAND: 1000,
    TEN_THOUSAND: 10000,
    TWENTY_THOUSAND: 20000,
  };

export const BULK_TEMPLATE_FILES = {
  BASE_URL: '/assets/tfb-acctmgmt/content-and-assets/bulk-upload-xlsx-templates/',
  CHANGE_NUMBER: 'BulkTemplate_ChangeMSISDN.xlsx',
  SIM_CHANGE: 'BulkTemplate_SimSwap.xlsx',
  ESIM_CHANGE: 'BulkTemplate_ESimSwap.xlsx',
  SUSPEND: 'BulkTemplate_Suspend.xlsx',
  SUSPEND_IAM: 'BulkTemplate_Suspend_Iam.xlsx',
  SUSPEND_ACCOUNT_TYPE_G: 'BulkTemplate_Suspend_AccTypeG.xlsx',
  RESTORE: 'BulkTemplate_Restore.xlsx',
  TRANSFER_NUMBERS: 'BulkTemplate_TransferNumbers.xlsx',
  LINE_IDENTIFIERS: 'BulkTemplate_LineIdentifier.xlsx',
  BASE_CSVURL: '/assets/tfb-acctmgmt/content-and-assets/bulk-upload-csv-templates/',
  CHANGE_NUMBER_CSV: 'BulkTemplate_ChangeMSISDN.csv',
  SIM_CHANGE_CSV: 'BulkTemplate_SimSwap.csv',
  ESIM_CHANGE_CSV: 'BulkTemplate_ESimSwap.csv',
  SUSPEND_CSV: 'BulkTemplate_Suspend.csv',
  RESTORE_CSV: 'BulkTemplate_Restore.csv',
  TRANSFER_NUMBERS_CSV: 'BulkTemplate_TransferNumbers.csv',
  LINE_IDENTIFIERS_CSV:'BulkTemplate_LineIdentifier.csv',
  FORM_INPUT: 'input',
  PASSWORD: 't-mobile',
  CANCEL_SUBSCRIBER: 'BulkTemplate_CancelSubscriber.xlsx',
  CANCEL_SUBSCRIBER_CSV: 'BulkTemplate_CancelSubscriber.csv',
  CHANGE_SERVICE: 'BulkTemplate_ChangeService.xlsx',
  CHANGE_SERVICE_CSV: 'BulkTemplate_ChangeService.csv',
  MANAGE_PAIRING_XLSX: 'BulkTemplate_ManagePairing.xlsx',
  MANAGE_PAIRING_CSV: 'BulkTemplate_ManagePairing.csv',
  STRATEGIC_PORT_IN_XLSX: 'BulkTemplate_StrategicPortIn.xlsx',
  STRATEGIC_PORT_IN_CSV: 'BulkTemplate_StrategicPortIn.csv',
  TPOP_XLSX: 'BulkTemplate_GenerateTPOP.xlsx',
};

export const BULK_ERROR_MESSAGES = {
  NO_DATA: 'Error Uploading file, No Data found. Please try again.',
  MISSING_MSISDN: 'Error Uploading file,Phone Number cannot be null or invalid. Please try again.',
};

export const SUSPEND_CONSTANTS = {
  TEMP_SUSPEND : 'TMPS',
  SUSPEND_WITHOUT_CHARGES : 'RSQ',
  SUSPEND_WITH_CHARGES : 'RSS',
  LOST_STOLEN_SUSPEND : 'ELST',
  SEASONAL_SUSPEND : 'SSQ',
  MILTARY_SUSPEND: 'MSS',
  EDUCATION_SUMMER_SUSPEND: 'EDUS',
  IMPLEMENTATION_SUSPEND: 'IMS',
  MCSA_CONTRACTUAL_SUSPEND: 'MIMS',
  SUNC_SUSPEND: 'SUNC',
  RETENTION_SUSPEND: "RETN",
  RETENTION_SUSPEND_TXT: "Retention Suspend (Gov Only)",
  RETENTION_SUSPEND_UNDERSCORE_TXT: "Retention_Suspend_(Gov_Only)",
  TEMP_SUSPEND_TXT : 'Temporary Suspend',
  SUSPEND_WITHOUT_CHARGES_TXT : 'Reseller Suspend without charges',
  SUSPEND_WITH_CHARGES_TXT : 'Reseller Suspend with charges',
  LOST_STOLEN_SUSPEND_TXT : 'Lost/Stolen Suspend',
  SEASONAL_SUSPEND_TXT : 'Seasonal Suspend',
  EDUCATION_SUMMER_SUSPEND_TXT : 'Education Summer Suspend',
  IMPLEMENTATION_SUSPEND_TXT : 'Implementation Suspend',
  MCSA_CONTRACTUAL_SUSPEND_TXT: 'MCSA Contractual Suspend',
  SUNC_SUSPEND_TXT: 'Special Unlimited Suspend',
  TEMP_SUSPEND_UNDERSCORE_TXT : 'Temporary_Suspend',
  SUSPEND_WITHOUT_CHARGES_UNDERSCORE_TXT : 'Reseller_Suspend_without_charges',
  SUSPEND_WITH_CHARGES_UNDERSCORE_TXT : 'Reseller_Suspend_with_charges',
  LOST_STOLEN_SUSPEND_UNDERSCORE_TXT : 'Lost/Stolen_Suspend',
  SEASONAL_SUSPEND_UNDERSCORE_TXT : 'Seasonal_Suspend',
  EDUCATION_SUMMER_SUSPEND_UNDERSCORE_TXT: 'Education_Summer_Suspend',
  IMPLEMENTATION_SUSPEND_UNDERSCORE_TXT : 'Implementation_Suspend',
  MCSA_CONTRACTUAL_SUSPEND_UNDERSCORE_TXT: 'MCSA_Contractual_Suspend',
  SPECIAL_UNLIMITED_SUSPEND_UNDERSCORE_TXT: 'Special_Unlimited_Suspend',
  SENIOR_MANAGER : 'SENIOR MANAGER',
  DIRECTOR : 'DIRECTOR',
  VP : 'VP',
  DIRECTOR_AND_VP: 'DIRECTOR AND VP',
  SALES_VP_AND_QA_TEAM: 'SALES VP AND QA TEAM',
  SALES_REP_INITIATED : 'SALES REP INITIATED',
  B2B_MARKETING_MANAGER: 'B2B MARKETING MANAGER' ,
  SALES_DIRECTOR : 'SALES DIRECTOR',
  GOVERNMENT_SALES : 'GOVERNMENT SALES',
  CUSTOMER_INITIATED : 'CUSTOMER INITIATED',
  PRICING_TEAM: 'PRICING TEAM',
  MILTARY_SUSPEND_TXT: 'MSS',
  ACCOUNT_TYPE_G : 'G',
  ACTIVE: 'ACTIVE',
  SUCCESS: 'SUCCESS',
  SUSPEND_SERVICE: 'suspend-service',
  CLOSE_SUSPEND_MODAL: 'closeSuspendModal',
  SUSPEND_TEMPLATE_FILE_NAME: 'Suspend Download Template',
  SUSPEND_ERROR: { code: 'SECURITY-1001', userMessage: 'Server error occured' },
  APPROVER_TYPES : {
    SR_MANAGER: 'SR_MANAGER',
    DIRECTOR: 'DIRECTOR',
    VP: 'VP',
    SALES_REP_INITIATED: 'SALES_REP_INITIATED',
    B2B_MARKETING_MANAGER: 'B2B_MARKETING_MANAGER',
    SALES_DIRECTOR: 'SALES_DIRECTOR',
    CUSTOMER_INITIATED: 'CUSTOMER_INITIATED',
    PRICING_TEAM: 'PRICING_TEAM',
    GOVERNMENT_SALES : 'GOVERNMENT_SALES',
    DIRECTOR_AND_VP: 'DIRECTOR_AND_VP',
    SALES_VP_AND_QA_TEAM: 'SALES_VP_AND_QA_TEAM'
    },
};

export const TRANSFER_NUMBER_CONSTANTS = {
  REASON_CODE_PR: 'PR',
  ELIGIBILITY_REQ_TYPE: 'changeMsisdn',
  TRAN_NUMBER : 'tranNumber',
  IS_VALID_NUMBER_TO_TFR : 'isValidNumberToTfr',
  ERROR_ON_SUCCESS_MSG : 'errorOrSuccessMessage',
  ACCOUNT_PIN_PASS : 'accountPinPass',
  PORT_TIME : 'portTime',
  PORT_DATE : 'portDate',
  MSISDN : 'msisdn',
  CARRIER_NUMBER : 'carrierNumber'
};
export const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
'July', 'August', 'September', 'October', 'November', 'December'];

export const smallMonthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const monthName = ['1', '2', '3', '4', '5', '6',
'7', '8', '9', '10', '11', '12'];

export class ColumnDefinition {
  headerName: string;
  dataType: string;
  range: any;
  length: number;
  minDate: Date;
  maxDate: Date;
}

export class ColumnDefinitionDateStr {
  headerName: string;
  dataType: string;
  range: any;
  length: number;
  minDate: string;
  maxDate: string;
}
export const MSISDN_CHANGE_REASONS = [
  {
    id: 'CUSTEMPMOVED',
    code: 'PR',
    description: 'Customer/Employee moved',
  },
  {
    id: 'CUSTEMPREQ',
    code: 'CR',
    description: 'Customer/Employee request',
  },
  {
    id: 'HRSPHNCALLS',
    code: 'PR',
    description: 'Harassing phone calls',
  },
  {
    id: 'INCORCTNPANXX',
    code: 'PR',
    description: 'Incorrect area code/prefix',
  },
  {
      id: 'NEWUSER',
      code: 'PR',
      description: 'New user',
  },
];

export const SIM_SWAP_REASONS = [
  {
    id: 'LSDSIM',
    code: 'LS',
    description: 'Lost/Stolen/Damaged SIM',
  },
  {
    id: 'CUSTEMPREQ',
    code: 'CR',
    description: 'Customer/Employee Request',
  },
  {
    id: 'DEFSIM',
    code: 'DFS',
    description: 'Validated Defective SIM',
  },
  {
    id: 'SIMKIT',
    code: 'BYOS',
    description: 'Customer SIM/SIM in Kit',
  },
];

export const ENTITLEMENT_ACTIVITYNAMES = {
  SIM_SWAP_SINGLE: 'SIM_SWAP_SINGLE',
  SIM_SWAP_BULK: 'SIM_SWAP_BULK',
  SUSPEND_SINGLE: 'SUSPEND_SINGLE',
  SUSPEND_BULK: 'SUSPEND_BULK',
  RESTORE_SINGLE: 'RESTORE_SINGLE',
  RESTORE_BULK: 'RESTORE_BULK',
  CHANGE_NUMBER_SINGLE: 'CHANGE_NUMBER_SINGLE',
  CHANGE_NUMBER_BULK: 'CHANGE_NUMBER_BULK',
  PORT_IN: 'PORT_IN',
  TRANSACTION_HISTORY: 'TRANSACTION_HISTORY',
  TRANSACTION_HISTORY_LH: 'TRANSACTION_HISTORY_LH',
  LINE_IDENTIFIER : 'LINE_IDENTIFIER',
  LINE_IDENTIFIER_BULK : 'LINE_IDENTIFIER_BULK',
  TRANSFER_NUMBER : 'PORT_IN',
  CHANGE_SERVICES : 'CHANGE_SERVICES',
  VIEW_LINE_HISTORY : 'VIEW_LINE_DETAILS',
  CHANGE_SERVICE_SINGLE: 'CHANGE_SERVICES',
  CHANGE_SERVICE_BULK: 'CHANGE_SERVICES_BULK_AH',
  CANCEL_SERVICE: 'CANCEL_SERVICE_AH',
  CANCEL_SERVICE_BULK: 'CANCEL_SERVICE_BULK_AH',
  MANAGE_PAIRING_SINGLE: 'MANAGE_PAIRING_SINGLE',
  MANAGE_PAIRING_BULK: 'MANAGE_PAIRING_BULK',
  STRATEGIC_PORT_IN_BULK: 'STRATEGIC_PORT_IN_BULK',
  // Activity to allow submission
  VERIFY_AFFILIATION_SUBMIT: 'AFFILIATION_VERIFICATION_SUBMIT',
  // Activity to see flow only
  PARTNER_SUBSCRIPTION_REDEMPTION: 'PARTNER_SUBSCRIPTION_REDEMPTION_AH',
  VERIFY_AFFILIATION: 'AFFILIATION_VERIFICATION',
  UPGRADE: 'UPGRADE',
  ADD_LINE: 'ADD_A_LINE-SIMONLY_BYOD',
  ADD_ACCOUNT_FRIENDLY_NAME: 'BAN_FRIENDLY_NAME',
  AUTOPAY_ENROLLMENT:'AUTOPAY_ENROLLMENT',
  UPDATE_BILLING_ACCOUNT_PASSWORD: 'UPDATE_BILLING_ACCOUNT_PASSWORD',
  BILL_DELIVERY: 'PAPERLESS_BILLING_ENROLLMENT',
  DEFAULT_ADDRESS: 'UPDATE_BILLING_ADDRESS',
  CHANGE_RATE_PLAN: 'CHANGE_RATE_PLAN',
  LINE_OF_SERVICE: 'LINE_OF_SERVICE',
  // For sidenav links
  MANAGE_LINES: 'ACCOUNT_LOOKUP',
  TRANSACTIONS: 'TRANSACTION_HISTORY',
  MANAGE_USERS: 'MANAGE_USERS_AH',
  SHOP_CATALOG: 'ADD_A_LINE-SIMONLY_BYOD',
  UPGRADES: 'UPGRADE',
  ORDER_HISTORY: 'ORDER_HISTORY',
  CART: 'CHECKOUT_CART',
  OVERVIEW: 'VIEW_BILL',
  ANALYZE_BILL: 'IBILLING_REPORTS',
  REPORTS: 'IBILLING_REPORTS',
  SETTINGS: 'GENERAL',
  APPROVAL_DASHBOARD: 'IS_APPROVER',
  //account Detail
  ACCOUNT_DETAIL: 'VIEW_ACCOUNT_DETAILS',
  LINE_DETAILS: 'VIEW_LINE_DETAILS',
  USAGE_DETAILS: 'VIEW_UNBILLED_USAGE',
  MAKE_PAYMENTS: 'MAKE_PAYMENTS',
  VIEW_DASHBOARD_SINGLEBAN: 'VIEW_DASHBOARD_SINGLEBAN',
  VIEW_DASHBOARD_MULTIBAN: 'VIEW_DASHBOARD_MULTIBAN',
  VIEW_BAN_USAGE: "VIEW_BAN_USAGE",
  VIEW_BILL: "VIEW_BILL",
  LH_USER_NOTIFICATIONS: "LH_USER_NOTIFICATIONS",
  MANAGE_SIM_SWAP_BLOCK_SINGLE: "SIM_SWAP_BLOCK_UNBLOCK_SINGLE",
  MANAGE_SIM_SWAP_BLOCK_BULK: "SIM_SWAP_BLOCK_UNBLOCK_BULK",
  MANAGE_SIM_SWAP_BLOCK_UNBLOCK_BAN: "SIM_SWAP_BLOCK_UNBLOCK_BAN",
  MANAGE_PORT_OUT_PROTECTION_SINGLE:"PORT_OUT_BLOCK_UNBLOCK_SINGLE",
  MANAGE_PORT_OUT_PROTECTION_BULK:"PORT_OUT_BLOCK_UNBLOCK_BULK",
  MANAGE_TPOP_SINGLE: "MANAGE_TPOP_SINGLE",
  MANAGE_TPOP_BAN: "MANAGE_TPOP_BAN",
  MANAGE_TPOP_BULK: "MANAGE_TPOP_BULK",
  MANAGE_SIM_LOCK_UNLOCK_SINGLE:"SIM_DEVICE_LOCK_UNLOCK_SINGLE",
  MANAGE_SIM_LOCK_UNLOCK_BULK:"SIM_DEVICE_LOCK_UNLOCK_BULK",
  MANAGE_SIM_ON_OFF_PROTECTION_SINGLE:"TURN_ON_OFF_SIM_PROTECTION_SINGLE",
  MANAGE_SIM_ON_OFF_PROTECTION_BULK:"TURN_ON_OFF_SIM_PROTECTION_BULK",
  GENERATE_PORT_OUT_PIN: "MANAGE_TPOP_SINGLE",
  IOT_LINE_DETAILS: "IOT_AH"  
};

export const ERROR_CATEGORY: any = {
  FAILURE_SYSTEM_VALIDATION: 'FAILURE_SYSTEM_VALIDATION',
  FAILURE_BUSINESS_VALIDATION: 'FAILURE_BUSINESS_VALIDATION',
  HTTP_STATUS: 200,
};

export const RESTRICTEDPAGE: any = {
  restrictedPage: {
    restrictedPageTitleTxt: 'Restricted access',
    accessToPageTxt: 'Whoops, it seems that you do not have access to this page.',
    errorContactTxt: 'If you think that it is an error please contact Business Team of Experts',
    phoneContactTxt: 'by phone at 1 (800) 375-1126 or by dialing 611 from your T-Mobile phone.',
    backToLoginTxt: 'Back to Log-in',
    simProtectionEndUserMessage: "SIM Protection is on and you don't have permission to turn it off. Please contact your team admin."
  },
};

export const RATEPLANSERVICE: any = {
  CHANGE_RATE_PLAN_FLOW: 'changeRatePlanFlow',
  SELECT_PLAN: 'Select Plan',
  SELECT_SERVICE: 'Select Services',
  REVIEW_CONFIRM: 'Review & Confirm',
  CURRENT_PLAN: 'currentPlan',
  SELECTED_PLAN: 'selectedPlan',
  SCREEN_NAME: 'screenName',
  SERVICE_LIST: 'serviceList',
  INITIAL_LIST: 'initialList',
  PLAN_COLUMN: 'plan',
  YOUR_PRICE_COLUMN: 'yourprice',
  CURRENT: 'current',
  ELIGIBLE: 'eligibile',
  DATA: 'data',
  BLOCK: 'block',
  OTHER: 'other',
  SERVICE_COLUMN: 'service',
  CURRENT_SELECTED_SERVICE: 'currentSelectedService',
  PROTECTION_PLAN: 'ProtectionPlan',
  SOC: 'soc',
  LINE_SOC_CHANGE: 'LINE_SOC_CHANGE',
  ACCOUNT_CHANGE_PLAN: 'account_change_plan',
  ACCOUNT: 'account',
  IS_PLAN_CHANGE: 'isPlanChange',
  IS_SERVICE_CHANGE: 'isServiceChange',
  RATEPLANLIST:"ratePlanList",
  ADDEDPLANS:"addedPlans",
  REMOVEDPLANS:"removedPlans",
  ADDEDSERVICES:"addedServices",
  REMOVEDSERVICES:"removedServices",
  NETPRICE:"netPrice",
  ADDITIONALSERVICES:"additioanlServices",
  BAN:"BAN"
}

export const LINE_IDENTIFIER: any = {
  CONFIG_RESPONSE: 'configResponse',
  CONFIG_MODEL: 'configModel',
  CONFIG_NAME: 'configName',
  CONFIG_LABEL: 'configLabel',
  CONFIG_DESC: 'configDesc',
  CONFIG_VALUE: 'configValue',
  CONFIG_KEY: 'key',
  CONFIG_TYPE: 'configType',
  CONFIG_PICKLIST_VALUE: 'pickListValue',
  CONFIG_UDFIDPRIMARY: 'uDFIDPrimary',
  CONFIG_UDFID1: 'uDFID1',
  CONFIG_UDFID2: 'uDFID2',
  CONFIG_UDFID3: 'uDFID3',
  CONFIG_UDFID4: 'uDFID4',
  CONFIG_UDFID5: 'uDFID5',
  CONFIG_UDFID6: 'uDFID6',
  CONFIG_UDFID7: 'uDFID7',
  CONFIG_UDFID8: 'uDFID8',
  CONFIG_UDFID9: 'uDFID9',
  CONFIG_UDFID10: 'uDFID10',
  CONFIG_UDF1: 'udf1',
  CONFIG_UDF2: 'udf2',
  CONFIG_UDF3: 'udf3',
  CONFIG_UDF4: 'udf4',
  CONFIG_UDF5: 'udf5',
  CONFIG_UDF6: 'udf6',
  CONFIG_UDF7: 'udf7',
  CONFIG_UDF8: 'udf8',
  CONFIG_UDF9: 'udf9',
  CONFIG_UDF10: 'udf10',
  TARGET_SERVICE_NAME: 'line-identifier-update-v2',
  CACHED_LINE_IDENTIFIER_LINES: 'cachedLineIdentifierLines',
  LINE_IDENTIFIER_ERROR: { code: 'SECURITY-1001', userMessage: 'Server error occured' },
  DEFAULT_GROUP: 'Default BO Group',
  UDF_KEYS: ['udf1', 'udf2', 'udf3'],
  UDF_KEYS_CUP_NO_REGRETS: ['udf1', 'udf2', 'udf3', 'udf4', 'udf5'],
  UDF_KEYS_DH_CUP: ['udf1', 'udf2', 'udf3', 'udf4', 'udf5', 'udf6'],
  UDF_KEYS_DH: ['udf1', 'udf2', 'udf3', 'udf6'],
  UDFID_KEYS_DH: ['uDFID1', 'uDFID2', 'uDFID3', 'uDFID6'],
  UDFID_KEYS: ['uDFID1', 'uDFID2', 'uDFID3'],
  UDFID_KEYS_CUP_NO_REGRETS: ['uDFID1', 'uDFID2', 'uDFID3', 'uDFID4', 'uDFID5'],
  UDFID_KEYS_CUP_DH: ['uDFID1', 'uDFID2', 'uDFID3', 'uDFID4', 'uDFID5', 'uDFID6'],
  LAST_SLIDE: '4',
  PRIMARY_UDF:'primaryUDF',
  BILLING_CYCLE_MSG: "billing cycle",
  PICKLIST : "Picklist"
};

export const UPGRADEAPP: any = {
 URL_PART : '/upgrade/select-lines?uid=',
 ORG_PARAM:'&clientAppName=SSP&OrgID=',
 IDPESSION :'1-1O4IPGO'
}

export const SHOPCATALOGAPP: any = {
 URL_PART : '/add-a-line/plp?uid=',
 ORG_PARAM:'&clientAppName=SSP&OrgID='
}

export const ORDERHISTORYAPP: any = {
 URL_PART : '/order-history?uid=',
 ORG_PARAM:'&clientAppName=SSP&OrgID='
}

export const ORDERAPPROVALAPP: any = {
  URL_PART : '/orders-approval?uid=',
  ORG_PARAM:'&clientAppName=SSP&OrgID='
 }

 export const CARTAPP: any = {
  URL_PART : '/add-a-line/cart?uid=',
  ORG_PARAM:'&clientAppName=SSP&OrgID='
 }

export const PAYMENTAPP: any = {
  URL_PART : '/payment/makepayment?pid=',
  ORG_PARAM:'&OrgID='
}

export const AUTOPAYAPP: any = {
  URL_PART : '/payment/autopayment?pid=',
  ORG_PARAM:'&OrgID='
}

export const MANAGELINE_PLANSANDSERVICE: any = {
  FREE : 'free',
  SUCCESS:'SUCCESS',
  GSM :'GSM',
  PRODUCT:'PRODUCT',
  FORLINES:'(for phone lines only)',
  LI_TAG: '<li>'
 }
export const SOC_CONSTANTS_BIC = [['ILDBARSB', 'ILDBARSG'], ['ILDBARS', 'ILDBARSMI']];
export const SOC_CONSTANTS_BRD = [['NABINTAB', 'BINTALLB', 'NABINTAP', 'BINTALLF'], ['NABINTAS', 'BINTALLS']];
export const SOC_CONSTANTS_BIR = [['BINTWEBGB', 'BINTWEBGF'], ['BINTWEBGS', 'BINTWEBBS']];
export const SOC_CONSTANTS_BD = [[],['ZBLOCKMI']];
export const SOC_CONSTANTS_CFC = [[],['MBBWEBGRD']];
export const SOC_CONSTANTS_IDP1 = [[],['ZIDPAUDE']];
export const SOC_CONSTANTS_IDP2 = [[],['ZIDPBLKDE']];
export const SOC_CONSTANTS_IDP3 = [[],['ZIDPBBANS']];
export const SOC_CONSTANTS_MI_IDP1 = [[],['ZIDPADMI']];
export const SOC_CONSTANTS_MI_IDP2 = [[],['ZIDBLKMI']];
export const SOC_CONSTANTS_MI_IDP3 = [[],['ZIDPBBMI']];
export const IDP_SOC_LIST = ['ZIDPAUDE','ZIDPBLKDE','ZIDPBBANS','ZIDPADMI','ZIDBLKMI','ZIDPBBMI'];
export const COFFEE_JAGUAR_SAT_SOC = [[],['ZBLKSATCV', 'ZDCLSATCV']];

export const FIRST_RESPONDER: any = {
  AFFILIATION_TYPE: "FIRST_RESPONDER",
  REVERIFY_STATUS: "REVERIFY",
  DATE_DISPLAY_FORMAT: {
    parse: {
      dateInput: 'LL',
    },
    display: {
      dateInput: 'LL',
      monthYearLabel: 'MMM YYYY',
      dateA11yLabel: 'LL',
      monthYearA11yLabel: 'MMMM YYYY',
    },
  }
};

export const AFFILIATIONS: any = {
  AFFILIATION_TYPE: "affiliationType",
  NAME_EMAIL_DETAILS: "nameEmail",
  ACC_DETAILS: "affiliationDetails",
  VERIFYDOCAPI_REQBDY: "VerifyDocsApiReqBody",
  UPLOAD_STATUS_REVIEWED: "REVIEWED",
  UPLOAD_STATUS_PENDING: "PENDING",
  UPLOAD_STATUS_FAILED: "FAILED",
  UPLOAD_STATUS_NULL: "NULL",
  UPLOAD_STATUS_PENDING_REVIEWED: "PENDING_REVIEW",
  VERIFICATION_TYPES: "ASSET_REVIEW,AUTHORITATIVE",
}

export const MILITARY_PAGE: any = {
  IS_VETERAN:'isVeteran',
  EMAIL_REGEX: /^(?=.{1,50}$)[a-zA-Z][a-zA-Z0-9_.\-]*(\.[a-zA-Z][a-zA-Z0-9_.]*)?@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([\w-]{1,50}\.)+))([a-zA-Z0-9]{1,50})(\]?)$/,
  CURRENT_DATE_FORMAT: 'YYYY-MM-DD',
  REQUIRED_DATE_FORMAT: 'MM/DD/YYYY',
  DATE_FORMAT: 'YYYY-MM-DD',
  AFFILIATION_TYPE: "MILITARY",
  LOOKUP_REQBODY : {
    "affiliationType": "MILITARY"
  },
  BILLINGACCOUNT: "BillingAcount",
  PUBLICKEY_ENCRYPTION: "https://keyvault-prod./apps.px-prd02.cf.t-mobile.com/jwks/v1/prod/tfbpartnerserverrsakey1",
  FILE_FORMATS: ['bmp','gif','jpg','png','pdf'],
  NO_ACTIVE_LINES: "No active lines in the BAN",
  DISCHARGE_YEAR: 1899
};
export const APPROVAL_DASHBOARD_CONSTANTS: any = {
  LAST_30_DAYS: '30 days',
  LAST_60_DAYS: '60 days',
  LAST_90_DAYS: '90 days',
  THIRTY : '30',
  SIXTY : '60',
  NINETY : '90',
  MAX_COUNT : '99',
  TEN : '10',
  ONE : '1',
  APPROVED: 'Approved',
  REJECTED: 'Rejected',
  PENDING: 'Pending',
  APPROVED_VALUE: 'approved',
  REJECTED_VALUE: 'rejected',
  PENDING_VALUE: 'pending',
  ALL_REQUESTS: 'All requests',
  CHANGE_NUMBER: 'Change Number',
  ACC_CHANGE_NUMBER: 'account_change_number',
  ACC_CHANGE_SERVICES: 'account_change_services',
  ACCOUNT_CHANGE_RATE_PLAN: 'account_change_plan',
  ACC_CHANGE_SIM: 'account_change_simcard',
  ACC_RESTORE_LINE: 'account_restore_line',
  ACC_SUSPEND_LINE: 'account_suspend_line',
  ACC_TRANSFER_NUMBER: 'account_transfer_number',
  DURATION: 'duration',
  TYPE: 'type',
  STATUS: 'status',
  SUSPEND:'Suspend line',
  RESTORE:'Restore line',
  CHANGENUMBER:'Change Number',
  CHANGERATEPLAN: 'Change rate plan',
  CHANGESIM:'Change SIM',
  CHANGESERVICE:'Change Service',
  REQUEST_TAB: 'Request',
  TRANSFERNUMBER:'Transfer number',
  DATE_SUBMITTED:'dateSubmitted',
  HISTORY_TAB: 'History',
  DATE:'date',
  DESC:'desc',
  ALL:'All',
  APPROVE: '<img class="activeIcon" src="/assets/tfb-acctmgmt/images/activeIcon.svg" alt=""/> Approve',
  REJECT: '<img class="cancelIcon" src="/assets/tfb-acctmgmt/images/cancelIcon.svg" alt=""/> Reject',
  SUCCESS: "Success",
  FAILURE: "Failure",
  COMMENT_MAX_LENGTH: 1000,
  ERROR_CODE1:"TFB_ERR_42855",
  ERROR_CODE2:"TFB_ERR_42862",
  CHECK_BOX: "Chk",
  DAYS_LEFT: "days left",
  HOURS_LEFT: "hours left"
};

export const ANALYTICS: any = {
  CTA_NAME: 'ctaName',
  ASSET_TYPE: 'assetType',
  USER_SELECTION: 'userSelection',
  MODAL_NAME : 'modalName',
  LOAD: 'load',
  PAGE: 'page',
  MODAL: 'modal',
  CLICK:"click",
  CLICK_TO_ACTION:"clickToAction",
  CLICK_TO_NAVIGATE:"clickToNavigate",
  BUTTON:"Button",
  DROPDOWN: "Dropdown",
  ICONTEXT: "Icon",
  ACCOUNT_ALERT: "Account Alert",
  LINK:"Link",
  CLOSE: "Close",
  BULK_SUSPEND:"Bulk Suspend",
  BULK_RESTORE:"Bulk Restore",
  BULK_UPDATE_LINE_IDENTIFIER:"Bulk Update Line Identifier",
  BULK_CHANGE_NUMBER:"Bulk Change Number",
  FORM_NAME: "formName",
  STORE_ID: "storeID",
  PLACEMENT_ID: "PlacementID",
  DATA_ANALYTICS_ID: "dataAnalyticsID",
  MODULE_NAME: "ModuleName",
  PARENT_COMPONENT: "parentComponent",
  FORM_START: "form start",
  FORM_COMPLETE: "form complete",
  STAGE: "stage",
  NAME: "name",
  ICON: "Icon",
  EXPAND:"Expand",
  COLLAPSE:"Collapse",
  EVENTCATEGORY:"eventCategory",
  ALERTINFO:"alertInfo",
  ALERTCLICK:"alertclick",
  ERRORMODAL:"errormodal",
  EVENTTYPE:"eventType",
  ERRORTEXT:"errorText",
  SOCPAGECONTENT:"socPageContent",
  CURRENTLYACTIVESERVICES:"currentlyActiveServices",
  UPDATEDVOICEPLAN:"UpdatedVoicePlan",
  UPDATEDSERVICES:"updatedServices",
  NETPRICE:'netPrice',
  ADD:"add",
  RMV:"rmv",
  RATEPLANURL:"/account-management/change-rateplan",
  SELECTSERVICES:"Select Services",
  REVIEWCONFIRM:"Review and Confirm",
  ACCOUNT:"Account",
  CHANGERATEPLAN:"Change Rate Plan",
  RATEPLANTYPE:"tfb_changerateplan",
  SERVICEPAGETYPE:"tfb_selectservices",
  REVIEWCONFIRMPAGETYPE:"tfb_changerateplan_review",
  INPROGRESSSTAGE:"in-progress",
  STARTSTAGE:"start",
  MANAGEACCOUNT :"Manage Accounts",
  STAGE_START: "start",
  SUBMIT: "Submit",
  DONE: "Done",
  COMPLETE: "complete",
  CANCEL: "Cancel",
  UPLOAD: "Upload",
  REPLACE: "Replace",
  DYNAMICCONTENT: "dynamicContent",
  LINE_NUMBER: "Line Number",
  TRANSFER_DATE_SELECTOR: "Transfer Date Selector",
  REMOVE_NUMBER: "Remove Number",
  CLEAR_ALL: "Clear All",
  REMOVE: "Remove",
  MULTILINE_NUMBER_TRANSFER: "Multi-line Number Transfer",
  STICKY_FOOTER: "Sticky Footer",
  CONFIRM: "Confirm",
  SITE_CARE: "TFB Care AHUB",
  SITE_AHUB: "TFB AHUB",
  PLANS_AND_SERVICES: "Plans and Services",
  LINES: "Lines",
  USAGE: "Usage",
  ACCOUNT_DETAIL: "Account Detail",
  TAB: "Tab",
  DOWNLOAD_LINE_DETAILS: "Download Line Details",
  XLS_FILE_FORMAT: "XLS File Format",
  CSV_FILE_FORMAT: "CSV File Format",
  CUSTOMIZE_TBL_LAYOUT: "Customize Table Layout",
  SAVE: "Save",
  LINE_IDENTIFIER_MODAL_NAME: "What is Line Identifiers",
  SKIP: "Skip",
  NEXT: "Next",
  CHANGE_NUMBERS: "Change Numbers",
  ADD_ACC_NAME: "Add Account Name",
  UPDATE_ACC_NAME: "Update Account Name",
  DEVICE: "Device",
  SUSPEND_MODAL_NAME: "Suspend These Lines",
  REASON_FOR_CHANGE: "Reason for Change",
  SUBMIT_CHANGE: "Submit Change",
  UPDATE_LINE_IDENTIFIER: "Update Line Identifier",
  VIEW_MORE: "View More",
  VIEW_LESS: "View Less",
  ALL_ACCOUNTS: "< All accounts",
  ALL_LINES: "< All lines"
};

export enum RESPONSIVE_STATE {
  DESKTOP = 'Desktop',
  MOBILE = 'Mobile',
  TABLET = 'Tablet'
}

export const ACCOUNT_LISTING: any = {
SELECTED_BAN_DETAILS:'selectedBanDetails',

};

export const ACCOUNT_DETAILS_AUTOPAY: any = {
  BANKICONIMG:"/assets/tfb-acctmgmt/images/bank-icon.svg",
  AUTOPAY:'auto-pay'

};

export const SIGNOFF: any={
  LOGOUT_NAME: "TMobile Logout",
  LOGOUT_CONTENT1: "Thank you",
  LOGOUT_CONTENT2: "You have been successfully logged out. Click below link to login again.",
  RELOGIN: "Relogin"
}

export enum CREDITCARDS {
  MC = '/assets/tfb-acctmgmt/images/mastercard.svg',
  VS = '/assets/tfb-acctmgmt/images/visa.svg',
  AM = '/assets/tfb-acctmgmt/images/amex.svg',
  DS = '/assets/tfb-acctmgmt/images/dicsover.svg',
  MASTERCARD = '/assets/tfb-acctmgmt/images/mastercard.svg',
  MSCD = '/assets/tfb-acctmgmt/images/mastercard.svg',
  VISA = '/assets/tfb-acctmgmt/images/visa.svg',
  AMEX = '/assets/tfb-acctmgmt/images/amex.svg',
  DISCOVER ='/assets/tfb-acctmgmt/images/dicsover.svg'
}

export const TRANSACTION_DESCRIPTION:any =
{
  "not available": {
    "service suspension": "~totalLineCount~ submitted",
    "suspend service": "~totalLineCount~ submitted",
    "sim card change": "~totalLineCount~ submitted",
    "service restoration": "~totalLineCount~ submitted",
    "number change": "~totalLineCount~ submitted",
    "autopay enrollment": "AutoPay enrollment for account ~ban~",
    "autopay update": "AutoPay information updated for account ~ban~",
    "autopay unenrollment": "AutoPay canceled for account ~ban~",
    "service change": "~totalLineCount~",
    "paperless billing enrollment": "Paperless enrollment for account ~ban~",
    "paperless billing unenrollment": "Paperless canceled for account ~ban~",
    "paperless billing update": "Paperless enrollment for account ~ban~",
    "line identifier update": "~totalLineCount~ submitted",
    "payment- one time": "One-time payment for account ~ban~",
    "payment- schedule": "Scheduled payment for account ~ban~",
    "payment- cancel": "Canceled scheduled payment for account ~ban~",
    "eip standalone payment": "EIP Loan payment for account ~ban~",
    "transfer number": "~totalLineCount~ submitted",
    "edit payment arrangement request": "PA not available for account ~ban~",
    "create payment arrangement request": "PA not available for account ~ban~",
    "delete payment agreement request": "PA not available for account ~ban~",
    "rate plan change":"Rate plan change for account # ~ban~",
    "cancel subscriber":"~totalLineCount~ not available",
    "turn on sim protection": "~totalLineCount~ submitted",
    "turn off sim protection": "~totalLineCount~ submitted",
    "turn on port out protection": "~totalLineCount~ submitted",
    "turn off port out protection":"~totalLineCount~ submitted",
    "unlock sim to device":"~totalLineCount~ submitted",
    "lock sim to device":"~totalLineCount~ submitted",
    "sim protection on": "~totalLineCount~ submitted",
    "sim protection off": "~totalLineCount~ submitted",
    "deactivate port out pin": "~totalLineCount~ submitted",
    "generate port out pin": "~totalLineCount~ submitted"
  },
  "pending approval": {
    "service suspension": "~totalLineCount~ pending for approval",
    "sim card change": "~totalLineCount~ pending for approval",
    "service restoration": "~totalLineCount~ pending for approval",
    "number change": "~totalLineCount~ pending for approval",
    "autopay enrollment": "~totalLineCount~ pending for approval",
    "autopay update": "~totalLineCount~ pending for approval",
    "autopay unenrollment": "~totalLineCount~ pending for approval",
    "service change": "~totalLineCount~ pending for approval",
    "paperless billing enrollment": "~totalLineCount~ pending for approval",
    "paperless billing unenrollment": "~totalLineCount~ pending for approval",
    "paperless billing update": "~totalLineCount~ pending for approval",
    "line identifier update": "~totalLineCount~ pending for approval",
    "payment- one time": "~totalLineCount~ pending for approval",
    "payment- schedule": "~totalLineCount~ pending for approval",
    "payment- cancel": "~totalLineCount~ pending for approval",
    "eip standalone payment": "~totalLineCount~ pending for approval",
    "edit payment arrangement request": "~totalLineCount~ pending for approval",
    "create payment arrangement request": "~totalLineCount~ pending for approval",
    "delete payment agreement request": "~totalLineCount~ pending for approval",
    "transfer number": "~totalLineCount~ pending for approval",
    "rate plan change": "~totalLineCount~ pending for approval",
    "cancel subscriber": "~totalLineCount~ pending for approval",
    "turn on sim protection": "~totalLineCount~ pending for approval",
    "turn off sim protection": "~totalLineCount~ pending for approval",
    "turn on port out protection": "~totalLineCount~ pending for approval",
    "turn off port out protection":"~totalLineCount~ pending for approval",
    "unlock sim to device":"~totalLineCount~ pending for approval",
    "lock sim to device":"~totalLineCount~ pending for approval",
    "sim protection on": "~totalLineCount~ pending for approval",
    "sim protection off": "~totalLineCount~ pending for approval",
    "deactivate port out pin": "~totalLineCount~ pending for approval",
    "generate port out pin": "~totalLineCount~ pending for approval"
  },

  "approved": {
    "service suspension": "~totalLineCount~ approved",
    "sim card change": "~totalLineCount~ approved",
    "service restoration": "~totalLineCount~ approved",
    "number change": "~totalLineCount~ approved",
    "autopay enrollment": "~totalLineCount~ approved",
    "autopay update": "~totalLineCount~ approved",
    "autopay unenrollment": "~totalLineCount~ approved",
    "service change": "~totalLineCount~ approved",
    "paperless billing enrollment": "~totalLineCount~ approved",
    "paperless billing unenrollment": "~totalLineCount~ approved",
    "paperless billing update": "~totalLineCount~ approved",
    "line identifier update": "~totalLineCount~ approved",
    "payment- one time": "~totalLineCount~ approved",
    "payment- schedule": "~totalLineCount~ approved",
    "payment- cancel": "~totalLineCount~ approved",
    "eip standalone payment": "~totalLineCount~ approved",
    "edit payment arrangement request": "~totalLineCount~ approved",
    "create payment arrangement request": "~totalLineCount~ approved",
    "delete payment agreement request": "~totalLineCount~ approved",
    "transfer number": "~totalLineCount~ approved",
    "rate plan change":"~totalLineCount~ approved",
    "cancel subscriber": "~totalLineCount~ approved",
    "turn on sim protection": "~totalLineCount~ approved",
    "turn off sim protection": "~totalLineCount~ approved",
    "turn on port out protection": "~totalLineCount~ approved",
    "turn off port out protection":"~totalLineCount~ approved",
    "unlock sim to device":"~totalLineCount~ approved",
    "lock sim to device":"~totalLineCount~ approved",
    "sim protection on": "~totalLineCount~ approved",
    "sim protection off": "~totalLineCount~ approved",
    "deactivate port out pin": "~totalLineCount~ approved",
    "generate port out pin": "~totalLineCount~ approved"
    },

  "rejected": {
    "service suspension": "~totalLineCount~ rejected",
    "sim card change": "~totalLineCount~ rejected",
    "service restoration": "~totalLineCount~ rejected",
    "number change": "~totalLineCount~ rejected",
    "autopay enrollment": "~totalLineCount~ rejected",
    "autopay update": "~totalLineCount~ rejected",
    "autopay unenrollment": "~totalLineCount~ rejected",
    "service change": "~totalLineCount~ rejected",
    "paperless billing enrollment": "~totalLineCount~ rejected",
    "paperless billing unenrollment": "~totalLineCount~ rejected",
    "paperless billing update": "~totalLineCount~ rejected",
    "line identifier update": "~totalLineCount~ rejected",
    "payment- one time": "~totalLineCount~ rejected",
    "payment- schedule": "~totalLineCount~ rejected",
    "payment- cancel": "~totalLineCount~ rejected",
    "eip standalone payment": "~totalLineCount~ rejected",
    "edit payment arrangement request": "~totalLineCount~ rejected",
    "create payment arrangement request": "~totalLineCount~ rejected",
    "delete payment agreement request": "~totalLineCount~ rejected",
    "transfer number": "~totalLineCount~ rejected",
    "rate plan change":"~totalLineCount~ rejected",
    "cancel subscriber": "~totalLineCount~ rejected",
    "turn on sim protection": "~totalLineCount~ rejected",
    "turn off sim protection": "~totalLineCount~ rejected",
    "turn on port out protection": "~totalLineCount~ rejected",
    "turn off port out protection":"~totalLineCount~ rejected",
    "unlock sim to device":"~totalLineCount~ rejected",
    "lock sim to device":"~totalLineCount~ rejected",
    "sim protection on": "~totalLineCount~ rejected",
    "sim protection off": "~totalLineCount~ rejected",
    "deactivate port out pin": "~totalLineCount~ rejected",
    "generate port out pin": "~totalLineCount~ rejected"
  },

  "failure": {
    "service suspension": "~totalLineCount~ failed",
    "sim card change": "~totalLineCount~ failed",
    "service restoration": "~totalLineCount~ failed",
    "number change": "~totalLineCount~ failed",
    "autopay enrollment": "AutoPay enrollment for account ~ban~",
    "autopay update": "AutoPay information updated for account ~ban~",
    "autopay unenrollment": "AutoPay canceled for account ~ban~",
    "service change": "~totalLineCount~ failure",
    "paperless billing enrollment": "Paperless enrollment for account ~ban~",
    "paperless billing unenrollment": "Paperless canceled for account ~ban~",
    "paperless billing update": "Paperless enrollment for account ~ban~",
    "line identifier update": "~totalLineCount~ failed",
    "payment- one time": "One-time payment for account ~ban~",
    "payment- schedule": "Scheduled payment for account ~ban~",
    "payment- cancel": "Canceled scheduled payment for account ~ban~",
    "eip standalone payment": "EIP Loan payment for account ~ban~",
    "edit payment arrangement request": "PA update failed for account ~ban~",
    "create payment arrangement request": "PA create failed for account ~ban~",
    "delete payment agreement request": "PA cancel failed for account ~ban~",
    "transfer number": "~totalLineCount~ failed",
    "rate plan change":"Rate plan change for account # ~ban~",
    "cancel subscriber": "~totalLineCount~ failed",
    "device pairing": "~totalLineCount~ failed",
    "strategic port in": "~totalLineCount~ failed",
    "turn on sim protection": "~totalLineCount~ failed",
    "turn off sim protection": "~totalLineCount~ failed",
    "turn on port out protection": "~totalLineCount~ failed",
    "turn off port out protection":"~totalLineCount~ failed",
    "unlock sim to device":"~totalLineCount~ failed",
    "lock sim to device":"~totalLineCount~ failed",
    "sim protection on": "~totalLineCount~ failed",
    "sim protection off": "~totalLineCount~ failed",
    "deactivate port out pin": "~totalLineCount~ failed",
    "generate port out pin": "~totalLineCount~ failed"
  },
  "success": {
    "service suspension": "~totalLineCount~ successfully changed",
    "sim card change": "~totalLineCount~ successfully changed",
    "service restoration": "~totalLineCount~ successfully changed",
    "number change": "~totalLineCount~ successfully changed",
    "autopay enrollment": "AutoPay enrollment for account ~ban~",
    "autopay unenrollment": "AutoPay canceled for account ~ban~",
    "autopay update": "AutoPay information updated for account ~ban~",
    "service change": "~totalLineCount~ success",
    "paperless billing enrollment": "Paperless enrollment for account ~ban~",
    "paperless billing unenrollment": "Paperless canceled for account ~ban~",
    "paperless billing update": "Paperless enrollment for account ~ban~",
    "line identifier update": "~totalLineCount~ successfully changed",
    "payment- one time": "One-time payment for account ~ban~",
    "payment- schedule": "Scheduled payment for account ~ban~",
    "payment- cancel": "Canceled scheduled payment for account ~ban~",
    "eip standalone payment": "EIP Loan payment for account ~ban~",
    "transfer number": "~totalLineCount~ successfully changed",
    "edit payment arrangement request": "PA successfully updated for account ~ban~",
    "create payment arrangement request": "PA successfully created for account ~ban~",
    "delete payment agreement request": "PA successfully canceled for account ~ban~",
    "rate plan change":"Rate plan change for account # ~ban~",
    "cancel subscriber": "~totalLineCount~ success",
    "account migration": "Migrated account from Sprint to T-Mobile",
    "device pairing": "~totalLineCount~ successfully processed",
    "turn on sim protection": "~totalLineCount~ successfully changed",
    "turn off sim protection": "~totalLineCount~ successfully changed",
    "turn on port out protection": "~totalLineCount~ successfully changed",
    "turn off port out protection":"~totalLineCount~ successfully changed",
    "unlock sim to device":"~totalLineCount~ successfully changed",
    "lock sim to device":"~totalLineCount~ successfully changed",
    "sim protection on": "~totalLineCount~ successfully changed",
    "sim protection off": "~totalLineCount~ successfully changed",
    "deactivate port out pin": "~totalLineCount~ successfully changed",
    "generate port out pin": "~totalLineCount~ successfully changed"
  },
  "partial failure": {
    "service suspension": "~totalLineCount~ changed",
    "sim card change": "~totalLineCount~ changed",
    "service restoration": "~totalLineCount~ changed",
    "number change": "~totalLineCount~ changed",
    "autopay enrollment": "AutoPay enrollment for account ~ban~",
    "autopay update": "AutoPay information updated for account ~ban~",
    "autopay unenrollment": "AutoPay canceled for account ~ban~",
    "service change": "~totalLineCount~ partial failure",
    "paperless billing enrollment": "Paperless enrollment for account ~ban~",
    "paperless billing unenrollment": "Paperless canceled for account ~ban~",
    "paperless billing update": "Paperless enrollment for account ~ban~",
    "line identifier update": "~totalLineCount~  changed",
    "payment- one time": "One-time payment for account ~ban~",
    "payment- schedule": "Scheduled payment for account ~ban~",
    "payment- cancel": "Canceled scheduled payment for account ~ban~",
    "eip standalone payment": "EIP Loan payment for account ~ban~",
    "transfer number": "~totalLineCount~ changed",
    "edit payment arrangement request": "PA updated for account ~ban~",
    "create payment arrangement request": "PA created for account ~ban~",
    "delete payment agreement request": "PA canceled for account ~ban~",
    "rate plan change":"Rate plan change for account # ~ban~",
    "cancel subscriber": "~totalLineCount~ partial failure",
    "device pairing": "~totalLineCount~ processed with errors",
    "strategic port in": "~totalLineCount~ changed",
    "turn on sim protection": "~totalLineCount~ changed",
    "turn off sim protection": "~totalLineCount~ changed",
    "turn on port out protection": "~totalLineCount~ changed",
    "turn off port out protection":"~totalLineCount~ changed",
    "unlock sim to device":"~totalLineCount~ changed",
    "lock sim to device":"~totalLineCount~ changed",
    "sim protection on": "~totalLineCount~ changed",
    "sim protection off": "~totalLineCount~ changed",
    "deactivate port out pin": "~totalLineCount~ changed",
    "generate port out pin": "~totalLineCount~ changed"
  },
  "complete": {
    "transfer number": "~totalLineCount~ successfully changed",
    "strategic port in": "~totalLineCount~ completed"
  },
  "error": {
    "transfer number": "~totalLineCount~ failed"
  },
  "submitted": {
    "transfer number": "~totalLineCount~ scheduled",
    "strategic port in": "~totalLineCount~ submitted",
  },
  "save": {
    "transfer number": "~totalLineCount~ scheduled"
  },
  "open": {
    "transfer number": "~totalLineCount~ scheduled"
  },
  "cancelled": {
    "transfer number": "~totalLineCount~ cancelled"
  },
  "pending":{
    "strategic port in": "~totalLineCount~ pending"
  }
};

export const CANCEL_SUBSCRIBER_REASONS : any = [
  {
    "id": "BILLPROB",
    "code": "BILL",
    "description": "Billing problems"
  },
  {
    "id": "COVEISSUES",
    "code": "HCOV",
    "description": "Coverage Issues"
  },
  {
    "id": "LOSTEQUIP",
    "code": "ELST",
    "description": "Lost or Stolen equipment"
  },
  {
    "id": "LOWUSE",
    "code": "LOWU",
    "description": "Low Usage"
  },
  {
    "id": "NOLONGEREMP",
    "code": "FACX",
    "description": "No Longer an Employee"
  }
];

export const GENERIC_ERROR_MSGS: any = {
  INTERNAL_ERR: 'Internal Error',
  INTERNAL_SERVER_ERR: 'An internal server error occurred'
}

// Bulk Change Service is only available during
// Pilot Project for participating ORGs
export const PILOT_CHANGE_SERVICE_ORGS: any = [
  '2-4KFCC4K2',
  '2-60QDVZE8',
  '2-350B7W71',
  '1-496MCH9'
]

export const MANAGE_PAIRING: any = {
  PAIR: "PAIR",
  UNPAIR: "UNPAIR"
}

export const TEA_LINE_STATUS: any = {
  ACTIVE_CODE: "A",
  SUSPEND_CODE: "S"
};
